{
  "common": {
    "save": "Salva",
    "cancel": "Annulla",
    "retry": "Riprova",
    "dismiss": "Ignora",
    "confirm": "Conferma",
    "delete": "Elimina",
    "deleting": "Eliminazione…",
    "creating": "Creazione…",
    "edit": "Modifica",
    "you": "Tu",
    "signOut": "Esci",
    "backToHome": "Torna alla home",
    "pleaseTryAgain": "Riprova.",
    "copy": "Copia",
    "noWorkspaceSelected": "Nessun workspace selezionato.",
    "color": "Colore",
    "reset": "Reimposta",
    "discard": "Scarta",
    "discardChangesTitle": "Scartare le modifiche?",
    "discardChangesBody": "Hai modifiche che non hai salvato. Se chiudi ora vanno perse.",
    "saving": "Salvataggio",
    "diff": {
      "summary": "{removed} rimosse · {added} aggiunte"
    },
    "back": "Indietro",
    "next": "Avanti",
    "sortBy": "Ordina per",
    "sortAsc": "Ordinato in modo crescente",
    "sortDesc": "Ordinato in modo decrescente",
    "table": {
      "range": "{from}-{to} di {total}",
      "pageSize": "Righe per pagina",
      "previous": "Pagina precedente",
      "next": "Pagina successiva",
      "selectRow": "Seleziona riga",
      "empty": "Ancora niente da mostrare"
    },
    "copyFailed": "Impossibile copiare"
  },
  "errors": {
    "somethingWentWrong": "Qualcosa è andato storto.",
    "offline": "Sei offline. Controlla la connessione e riprova.",
    "rateLimited": "Troppe richieste. Attendi un momento e riprova.",
    "sessionExpired": "La sessione è scaduta. Accedi di nuovo.",
    "notFoundTitle": "Pagina non trovata",
    "notFoundDescription": "La pagina che cerchi non esiste.",
    "unknownError": "Si è verificato un errore sconosciuto.",
    "planRun": {
      "enqueueFailed": "Raldo non è riuscito ad avviare il piano. Riprova.",
      "inProgress": "Un piano è già in corso. Aspetta che finisca.",
      "failed": "Il piano si è fermato per un errore. Riprova.",
      "domainUnknown": "Raldo non conosce ancora il tuo sito. Aggiungilo prima.",
      "marketUndecided": "Scegli prima il mercato in cui vendi.",
      "siteUnreachable": "Raldo non è riuscito a raggiungere il tuo sito. Controlla che sia online.",
      "rawStoreFailed": "Raldo non è riuscito a salvare ciò che ha trovato. Riprova.",
      "stageDeadlineExceeded": "Un passaggio ha richiesto troppo tempo. Riprova.",
      "vendorBudgetExhausted": "I dati di ricerca non sono disponibili al momento. Riprova più tardi.",
      "vendorNotConfigured": "I dati di ricerca non sono ancora configurati.",
      "vendorHttpError": "Il servizio dei dati di ricerca non ha risposto. Riprova più tardi.",
      "vendorEnvelopeError": "Il servizio dei dati di ricerca ha inviato una risposta errata. Riprova più tardi.",
      "contentFetchFailed": "Raldo non è riuscito a leggere le tue pagine. Riprova.",
      "beliefsMissing": "Raldo ha prima bisogno dei tuoi argomenti. Impostali e riprova.",
      "brandFactsMissing": "Raldo ha prima bisogno dei dati del tuo brand. Compilali e riprova.",
      "discoveryNoSeeds": "Raldo non ha trovato ricerche da cui partire. Riprova.",
      "modelOutputInvalid": "Raldo ha ricevuto una risposta che non ha potuto usare. Riprova.",
      "timedOut": "Il piano ha richiesto troppo tempo. Riprova.",
      "relevanceNothingKept": "Nessuna ricerca è abbastanza vicina alla tua azienda. Controlla i fatti del brand e riprova.",
      "serpNoResults": "Raldo non ha ricevuto risultati di ricerca. Riprova più tardi.",
      "noPagesKept": "Ogni pagina è stata esclusa. Controlla i fatti del brand e riprova.",
      "focusNothingNew": "Non sono state trovate nuove pagine per questo tema."
    },
    "visibilityRun": {
      "enqueueFailed": "Raldo non è riuscito ad avviare la misurazione. Riprova.",
      "inProgress": "Una misurazione è già in corso. Aspetta che finisca.",
      "failed": "La misurazione si è fermata per un errore. Riprova.",
      "noPrompts": "Raldo non ha trovato domande da porre. Controlla il tuo piano e riprova.",
      "noPlan": "Raldo ha prima bisogno del tuo piano. Pianifica le tue pagine e riprova.",
      "costCap": "La misurazione si è fermata prima, quindi mancano alcune risposte.",
      "marketUndecided": "Scegli prima il mercato in cui vendi.",
      "brandFactsMissing": "Raldo ha prima bisogno dei dati del tuo brand. Compilali e riprova.",
      "modelOutputInvalid": "Raldo ha ricevuto una risposta che non ha potuto usare. Riprova.",
      "rawStoreFailed": "Raldo non è riuscito a salvare ciò che ha trovato. Riprova.",
      "stageDeadlineExceeded": "Un passaggio ha richiesto troppo tempo. Riprova.",
      "vendorBudgetExhausted": "Le risposte IA non sono disponibili al momento. Riprova più tardi.",
      "vendorNotConfigured": "Le risposte IA non sono ancora configurate.",
      "vendorHttpError": "Il servizio delle risposte IA non ha risposto. Riprova più tardi.",
      "vendorEnvelopeError": "Il servizio delle risposte IA ha inviato una risposta errata. Riprova più tardi.",
      "contentFetchFailed": "Raldo non è riuscito a leggere le tue pagine. Riprova.",
      "timedOut": "La misurazione ha richiesto troppo tempo. Riprova."
    },
    "articleRun": {
      "enqueueFailed": "Raldo non è riuscito ad avviare la pagina. Riprova.",
      "inProgress": "Questa pagina è già in scrittura. Aspetta che finisca.",
      "failed": "La pagina si è fermata per un errore. Riprova.",
      "rawStoreFailed": "Raldo non è riuscito a salvare ciò che ha trovato. Riprova.",
      "stageDeadlineExceeded": "Un passo ha impiegato troppo tempo. Riprova.",
      "pageUnknown": "Raldo non conosce questa pagina. Pianifica di nuovo le tue pagine.",
      "noPlanRun": "Raldo ha prima bisogno di un piano finito. Pianifica le tue pagine e riprova.",
      "noSources": "Raldo non è riuscito a leggere nessuna pagina che si posiziona per questa domanda. Riprova più tardi.",
      "noScope": "Raldo non ha trovato nulla che la pagina debba coprire. Controlla la domanda e riprova.",
      "brandFactsMissing": "Raldo ha prima bisogno dei fatti del tuo brand. Compilali e riprova.",
      "marketUndecided": "Scegli prima il mercato in cui vendi.",
      "modelOutputInvalid": "Raldo ha ricevuto una risposta che non ha potuto usare. Riprova.",
      "vendorBudgetExhausted": "La ricerca non è disponibile al momento. Riprova più tardi.",
      "vendorNotConfigured": "La ricerca non è ancora configurata.",
      "vendorHttpError": "Il servizio di ricerca non ha risposto. Riprova più tardi.",
      "vendorEnvelopeError": "Il servizio di ricerca ha inviato una risposta errata. Riprova più tardi.",
      "contentFetchFailed": "Raldo non è riuscito a leggere una pagina. Riprova.",
      "timedOut": "La pagina ha impiegato troppo tempo. Riprova."
    },
    "postRun": {
      "enqueueFailed": "Raldo non è riuscito ad avviare il post. Riprova.",
      "inProgress": "Un post è già in scrittura. Aspetta che finisca.",
      "failed": "Il post si è fermato per un errore. Riprova.",
      "rawStoreFailed": "Raldo non è riuscito a salvare il suo lavoro. Riprova.",
      "stageDeadlineExceeded": "Un passaggio ha richiesto troppo tempo. Riprova.",
      "briefFailed": "Raldo non è riuscito a scrivere un brief che rispetti le regole. Riprova.",
      "noBelief": "La tua strategia non ha ancora un argomento per questo post.",
      "topicNotLinked": "Questo argomento non è ancora collegato a un tema. Collegalo prima a un tema.",
      "beliefMapMissing": "La tua strategia non ha ancora argomenti.",
      "brandFactsMissing": "I fatti del tuo brand non sono ancora confermati.",
      "marketUndecided": "Il tuo brand non ha ancora un mercato.",
      "modelOutputInvalid": "La risposta di Raldo non ha rispettato le regole. Riprova.",
      "timedOut": "Il post ha smesso di dare notizie ed è stato chiuso."
    }
  },
  "routes": {
    "chat": "Chat",
    "chats": "Chat passate",
    "document": "Documento",
    "design": "Design",
    "competitor": "Concorrente",
    "signIn": "Accedi",
    "checkYourEmail": "Controlla la tua email",
    "signingIn": "Accesso in corso",
    "yourName": "Il tuo nome",
    "workspaceSetup": "Configurazione del workspace",
    "setup": "Configurazione",
    "knowledge": "Conoscenze",
    "publishingSchedule": "Piano di pubblicazione"
  },
  "nav": {
    "chat": "Chat",
    "content": "Contenuti",
    "media": "Media",
    "account": "Account",
    "description": {
      "content": "I tuoi post e le tue pagine, settimana dopo settimana.",
      "media": "Un piccolo cassetto per tutto ciò che è visivo.",
      "competitors": "Gli altri nomi che i tuoi clienti valutano, e come ti confronti.",
      "arguments": "La tua tesi, un argomento alla volta.",
      "chats": "Riprendi ogni conversazione da dove l'hai lasciata.",
      "documents": "Uno scaffale di letture di contesto per Raldo.",
      "look": "I colori e i caratteri da cui ti riconoscono.",
      "voice": "La tua voce, perché niente suoni mai preso in prestito.",
      "inbox": "Cosa ha bisogno di te, e cosa ha fatto Raldo mentre eri via.",
      "plan": "Il tuo ritmo.",
      "customer": "La persona dall'altra parte di ogni post.",
      "settings": "Tutto il dietro le quinte, in un unico posto.",
      "company": "Cosa ha imparato Raldo su di te.",
      "visibility": "I clienti ti trovano? Diamo un'occhiata.",
      "pages": "Ogni pagina del tuo piano dei contenuti, per tema, nell'ordine in cui Raldo le scrive.",
      "posts": "Ogni post, con una data o senza."
    },
    "style": "Stile",
    "profile": "Profilo",
    "strategy": "Strategia",
    "topics": "Categorie",
    "arguments": "Argomenti",
    "calendar": "Bacheca",
    "voice": "Voce",
    "look": "Stile visivo",
    "brand": "Brand",
    "knowledge": "Conoscenze",
    "inbox": "In arrivo",
    "settings": "Impostazioni",
    "visibility": "Visibilità",
    "competitors": "Concorrenti",
    "kind": {
      "argument": "Argomento",
      "keyword": "Parola chiave",
      "prompt": "Prompt",
      "topic": "Categoria",
      "rival": "Concorrente",
      "page": "Pagina",
      "researchEntry": "Voce di ricerca",
      "post": "Post"
    },
    "research": "Ricerca",
    "pages": "Pagine",
    "posts": "Post"
  },
  "shell": {
    "guestName": "Segnaposto",
    "guestEmail": "you{'@'}raldo.app",
    "brandPlaceholder": "Il tuo brand",
    "sidebar": "Barra laterale",
    "collapseSidebar": "Comprimi barra laterale",
    "expandSidebar": "Espandi barra laterale",
    "primaryNav": "Principale",
    "resizeSidebar": "Ridimensiona la barra laterale",
    "resizeSidebarHint": "Trascina per ridimensionare · Clicca per comprimere",
    "expandSidebarHint": "Clicca per espandere",
    "darkTheme": "Tema scuro"
  },
  "auth": {
    "raldoHome": "Home di Raldo",
    "or": "oppure",
    "continueWithGoogle": "Continua con Google",
    "openingGoogleSignIn": "Apertura dell'accesso Google",
    "continue": "Continua",
    "email": "Email",
    "emailPlaceholder": "tuo{'@'}email.com",
    "termsOfService": "Termini di servizio",
    "privacyPolicy": "Informativa sulla privacy",
    "legal": "Accedendo accetti i nostri {terms} e la nostra {privacy}",
    "signIn": {
      "title": "Iniziamo",
      "subtitle": "Crea un account o accedi.",
      "emailError": "Inserisci un indirizzo email valido",
      "sendingLink": "Invio del link di accesso in corso"
    },
    "emailSent": {
      "resendCooldown": "Rinvia tra {seconds}s",
      "linkSent": "Link inviato ✓",
      "resendLink": "Rinvia link",
      "title": "Controlla la posta in arrivo",
      "sentTo": "Abbiamo inviato un magic link a",
      "expiry": "Clicca sul link nell'email per accedere. Il link scade tra 30 minuti.",
      "resending": "Invio del link in corso",
      "useDifferentEmail": "← Usa un'altra email"
    },
    "fullName": {
      "required": "Inserisci il tuo nome.",
      "title": "Come ti chiami?",
      "subtitle": "Lo useremo per personalizzare il tuo workspace.",
      "label": "Nome completo",
      "placeholder": "Mario Rossi",
      "saving": "Salvataggio del nome in corso"
    },
    "workspaceSetup": {
      "workspaceNameRequired": "Inserisci un nome per il workspace.",
      "brandNameRequired": "Inserisci un nome per il brand.",
      "title": "Configura il tuo workspace",
      "subtitle": "Ci siamo quasi. Dai un nome al tuo workspace per iniziare.",
      "workspaceNameLabel": "Nome del workspace",
      "workspaceNamePlaceholder": "Acme S.r.l.",
      "brandNameLabel": "Nome del brand",
      "brandNamePlaceholder": "es. Acme",
      "sameAsWorkspace": "Come il workspace",
      "submitting": "Configurazione in corso…",
      "continueCta": "Continua →"
    },
    "callback": {
      "signingIn": "Accesso in corso…",
      "signingInLoading": "Accesso in corso",
      "confirmTitle": "Conferma la tua email per continuare",
      "confirmBody": "Sembra che tu abbia aperto questo link su un altro dispositivo. Inserisci la tua email per completare l'accesso."
    },
    "toast": {
      "magicLinkFailed": "Impossibile inviare il link di accesso",
      "googleSignInFailed": "Accesso con Google non riuscito",
      "resendFailed": "Impossibile rinviare il link",
      "saveNameFailed": "Impossibile salvare il tuo nome",
      "createWorkspaceFailed": "Impossibile creare il tuo workspace",
      "signInFailed": "Impossibile completare l'accesso",
      "linkExpired": "Il link potrebbe essere scaduto. Inserisci la tua email per riprovare."
    },
    "errors": {
      "noEmailOnFile": "Nessuna email registrata per completare l'accesso con magic link."
    }
  },
  "billing": {
    "yearly": "Annuale",
    "monthly": "Mensile",
    "billedOnceYear": "{price} addebitati una volta all'anno",
    "billedEveryMonth": "Addebitato ogni mese",
    "perMonth": "/mese",
    "perYear": "/anno",
    "planOptionAriaLabel": "{name}, {price} al mese, {note}",
    "billingTerm": "Periodo di fatturazione",
    "headline": "Non perdere mai un post.",
    "chooseBilling": "Scegli la fatturazione",
    "vatNote": "Prezzi IVA esclusa. Le imposte dovute vengono calcolate al checkout.",
    "checkoutCta": "Metti Raldo al lavoro",
    "checkoutLoading": "Ti stiamo portando al checkout",
    "secureCheckout": "Checkout sicuro con Stripe · Annulla quando vuoi",
    "tagline": "La piattaforma di marketing agentica",
    "checkoutError": "Si è verificato un problema all'avvio del checkout. Riprova.",
    "title": "Fatturazione",
    "confirming": "Conferma del pagamento in corso",
    "confirmingHeading": "Conferma del pagamento in corso…",
    "confirmingBody": "Di solito richiede solo un secondo o due.",
    "stillConfirming": "Conferma del pagamento ancora in corso",
    "stillConfirmingBody": "Il pagamento potrebbe essere ancora in elaborazione. A volte può richiedere un po' più tempo del solito - controlla di nuovo tra poco, oppure contattaci se il problema persiste.",
    "checkAgain": "Controlla di nuovo",
    "contactSupport": "Contatta il supporto",
    "twoMonthsFree": "2 mesi gratis",
    "trialEnded": "La tua prova è terminata il {date}.",
    "accessCode": {
      "trigger": "Hai un codice di accesso?",
      "placeholder": "Codice di accesso",
      "apply": "Applica",
      "ariaLabel": "Codice di accesso",
      "invalid": "Questo codice di accesso non è valido. Controllalo e riprova.",
      "expired": "Questo codice di accesso è scaduto.",
      "exhausted": "Questo codice di accesso è già stato esaurito.",
      "alreadyMember": "Il tuo workspace ha già accesso.",
      "alreadyRedeemed": "Questo workspace ha già usato un codice di accesso.",
      "paymentRecovery": "La tua iscrizione ha un problema di pagamento. Risolvilo nella gestione della fatturazione."
    },
    "benefits": {
      "unlimitedTitle": "Contenuti illimitati",
      "unlimitedBody": "Crea bozze, progetta e programma quanto vuoi. Nessun credito, nessun limite, nessun conteggio.",
      "supportTitle": "Assistenza umana reale, 24/7",
      "supportBody": "Persone vere, quando ne hai bisogno. Tempo di risposta inferiore a 1 ora.",
      "guaranteeTitle": "Garanzia di rimborso di {days} giorni",
      "guaranteeBody": "Nessuna domanda."
    }
  },
  "account": {
    "membership": "Abbonamento Raldo",
    "status": {
      "active": "Attivo",
      "endsSoon": "In scadenza",
      "paymentIssue": "Problema di pagamento",
      "cancelled": "Annullato",
      "pending": "In attesa"
    },
    "renewsOn": "Si rinnova il {date}",
    "accessEndsOn": "L'accesso termina il {date}",
    "staysUsable": "Il tuo abbonamento resta pienamente utilizzabile fino ad allora.",
    "memberSince": "Membro dal {date}",
    "trial": {
      "badge": "Prova · {count} giorno rimasto | Prova · {count} giorni rimasti",
      "endsOn": "La prova termina il {date}",
      "thenPrice": "dopo la prova",
      "choosePlan": "Scegli un piano",
      "endTrial": "Termina la prova",
      "endDialogTitle": "Terminare la prova?",
      "endDialogWithDate": "Manterrai accesso completo fino al {date}. Dopo, la tua prova terminerà.",
      "endDialogWithoutDate": "Manterrai accesso completo fino alla fine della prova. Dopo, il tuo accesso terminerà."
    },
    "manageBilling": "Gestisci la fatturazione",
    "cancelSubscription": "Annulla abbonamento",
    "resumeSubscription": "Riattiva abbonamento",
    "market": {
      "title": "Mercato di ricerca",
      "description": "Dove Raldo misura posizionamenti, keyword e concorrenti. Un paese per lingua dei contenuti.",
      "current": "Mercato attuale",
      "source": {
        "languageDefault": "Predefinito per {language}",
        "overview": "Scelto in base a dove ti posizioni",
        "user": "Impostato da te"
      },
      "decided": "deciso il {date}",
      "candidates": "Dove si posiziona il tuo sito",
      "candidateTraffic": "{traffic} visite/mese",
      "candidateKeywords": "nessuna keyword | 1 keyword | {count} keyword",
      "selectLabel": "Paese",
      "rereadNote": "Se cambi il mercato, Raldo rilegge i tuoi dati di ricerca alla prossima misurazione.",
      "ownerOnly": "Solo i proprietari e gli admin possono cambiare il mercato.",
      "saving": "Salvataggio del mercato",
      "emptyTitle": "Conferma i dati del tuo brand per impostare il mercato",
      "toast": {
        "saved": "Mercato di ricerca aggiornato"
      }
    },
    "profile": "Profilo",
    "email": "Email",
    "nameLabel": "Nome",
    "namePlaceholder": "Il tuo nome",
    "toast": {
      "nameUpdated": "Nome aggiornato",
      "updateNameFailed": "Impossibile aggiornare il nome",
      "cancelDialogTitle": "Annullare il tuo abbonamento?",
      "cancelDialogWithDate": "Manterrai accesso completo fino al {date}. Dopo, il tuo abbonamento terminerà.",
      "cancelDialogWithoutDate": "Manterrai accesso completo fino alla fine del periodo di fatturazione attuale. Dopo, il tuo abbonamento terminerà.",
      "membershipEndsOn": "Il tuo abbonamento termina il {date}.",
      "membershipCancelled": "Il tuo abbonamento è stato annullato.",
      "cancelFailed": "Impossibile annullare l'abbonamento",
      "membershipRenews": "Il tuo abbonamento si rinnoverà come di consueto.",
      "resumeFailed": "Impossibile riattivare l'abbonamento",
      "billingPortalFailed": "Impossibile aprire il portale di fatturazione"
    }
  },
  "brand": {
    "connectedSince": "Collegato dal {date}",
    "disconnect": "Scollega",
    "ownerOnly": "Solo i proprietari del workspace possono gestire le connessioni.",
    "coreMessage": "Messaggio principale",
    "opportunity": "Opportunità",
    "foundationNote": "Fondamenta: ogni categoria sostenuta da prove concrete e dati di performance",
    "account": "Account",
    "linkedinDescription": "Pubblica post e caroselli direttamente sulla tua pagina aziendale.",
    "connectCta": "Collega {platform}",
    "toast": {
      "loadStatusFailed": "Impossibile caricare lo stato della connessione",
      "connectFailed": "Impossibile collegare {platform}",
      "disconnected": "{platform} scollegato",
      "disconnectFailed": "Impossibile scollegare {platform}",
      "saveFailed": "Impossibile salvare questa modifica",
      "viewerRoleMessage": "Il tuo ruolo può leggere questo brand, ma non modificarlo.",
      "markUploadFailed": "Impossibile caricare questo file"
    },
    "dialog": {
      "disconnectTitle": "Scollegare {platform}?",
      "disconnectLinkedinBody": "Scollegando LinkedIn, Raldo smette di pubblicare sulla tua pagina aziendale. Puoi ricollegarlo in qualsiasi momento."
    },
    "generating": "Sto scrivendo…",
    "section": {
      "edit": "Modifica",
      "editSection": "Modifica {section}",
      "saving": "Salvataggio"
    },
    "visualStyle": {
      "paletteTitle": "Palette",
      "paletteDescription": "Il primo colore è il primario. Raldo lo usa per i titoli e le forme principali.",
      "primaryColor": "Primario",
      "colorAt": "Colore {index}",
      "noColors": "Ancora nessun colore.",
      "removeColor": "Rimuovi {role}",
      "addColor": "Aggiungi un colore",
      "typefaceTitle": "Carattere",
      "typefaceDescription": "Applicato a ogni design che Raldo crea per questo brand.",
      "fontFamilyLabel": "Famiglia di caratteri",
      "marksTitle": "Marchi",
      "marksDescription": "Raldo sceglie il monogramma quando un design è piccolo o quadrato.",
      "logoMark": "Logo",
      "monogramMark": "Monogramma",
      "onLight": "Su chiaro",
      "onDark": "Su scuro",
      "noMarks": "Ancora nessun marchio.",
      "replaceMark": "Sostituisci",
      "addMark": "Aggiungi {mark}",
      "removeMark": "Rimuovi {mark}",
      "uploadingMark": "Caricamento…",
      "errors": {
        "invalidFileType": "Questo tipo di file non è supportato. Carica un'immagine PNG, JPEG, SVG o WebP.",
        "fileTooLarge": "Questo file è troppo grande. La dimensione massima è 2MB.",
        "uploadFailed": "Si è verificato un problema durante il caricamento di questo file. Riprova."
      },
      "quickLook": {
        "file": "File",
        "dimensions": "Dimensioni",
        "groundAriaLabel": "Sfondo dell'anteprima",
        "openAria": "Apri l'anteprima di {mark}"
      },
      "removeMarkAction": "Rimuovi"
    },
    "styleGuide": {
      "outlineLabel": "Parti di questa guida",
      "notSet": "Non ancora scritto.",
      "sectionPlaceholder": "Come questo brand tratta {section}",
      "termsDescription": "Raldo li corregge prima che una bozza arrivi a te.",
      "preferencesDescription": "Raldo non scrive nessuna parola della colonna a destra.",
      "sampleCopyDescription": "Dai tuoi post. Le prove dietro le sezioni qui sopra, così come sono state pubblicate.",
      "writtenWrongly": "Scritto male",
      "correctForm": "Forma corretta",
      "termPlaceholder": "es. meridian",
      "correctFormPlaceholder": "es. Meridian",
      "addTerm": "Aggiungi un termine",
      "useInstead": "Usa",
      "avoid": "Mai",
      "useInsteadPlaceholder": "es. nomina il passaggio che elimina",
      "avoidPlaceholder": "es. senza attriti",
      "addWord": "Aggiungi una parola",
      "removeRule": "Rimuovi {rule}",
      "noRulesYet": "Raldo le legge dai tuoi post pubblicati. Collega un account e questa parte si riempirà.",
      "connectAccounts": "Account collegati",
      "viewOriginalPost": "Vedi il post originale",
      "noSampleCopy": "Ancora nessun esempio di testo.",
      "parts": {
        "voiceAndPersonality": "Voce e personalità",
        "formalityAndAddress": "Formalità e modo di rivolgersi",
        "referenceGrammarStandard": "Standard grammaticale",
        "numbersDatesCurrency": "Numeri, date e valuta",
        "punctuationAndQuotes": "Punteggiatura e virgolette",
        "capitalization": "Uso delle maiuscole",
        "inclusiveLanguage": "Linguaggio inclusivo",
        "brandAndProductTerms": "Termini di brand e prodotto",
        "preferredAndAvoidedWords": "Parole da preferire ed evitare",
        "sampleCopy": "Esempi di testo"
      },
      "outline": {
        "voice": "Voce",
        "mechanics": "Meccanica",
        "rules": "Regole",
        "evidence": "Prove"
      }
    },
    "discardTitle": "Scartare le modifiche?",
    "discardBody": "Questo brief ha modifiche che non hai salvato. Se esci ora vanno perse.",
    "discardConfirm": "Scarta",
    "artifacts": {
      "contentStrategy": "Strategia dei contenuti",
      "look": "Stile visivo",
      "voice": "Voce",
      "beliefs": "Argomenti"
    },
    "notWritten": {
      "title": "{artifact} non è ancora stato scritto",
      "description": "Raldo lo scrive parlando con te. Chiediglielo su Home e comparirà qui.",
      "action": "Chiedi a Raldo",
      "askMessage": "Scrivi la mia {artifact}."
    },
    "connections": {
      "title": "Connessioni",
      "description": "Dove Raldo pubblica per tuo conto."
    },
    "schedule": {
      "title": "Programma di pubblicazione",
      "timeZoneLabel": "Fuso orario",
      "timeZoneHint": "Ogni orario qui sotto è letto in questo fuso.",
      "toggleDay": "Pubblica il {day}",
      "timeFor": "Orario di pubblicazione del {day}",
      "apply": "Applica",
      "days": {
        "monday": "Lun",
        "tuesday": "Mar",
        "wednesday": "Mer",
        "thursday": "Gio",
        "friday": "Ven",
        "saturday": "Sab",
        "sunday": "Dom"
      },
      "setEveryDayTo": "Imposta ogni giorno a",
      "everyDayTimeLabel": "Orario da applicare a ogni giorno"
    },
    "telegram": {
      "name": "Telegram",
      "description": "Chatta con Raldo dal telefono. Registra note, foto e note vocali ovunque tu sia.",
      "connectTitle": "Collega Telegram",
      "connectBody": "Inquadra il codice con la fotocamera. Telegram si apre e collega questo brand in automatico.",
      "qrAlt": "Codice QR che apre Raldo in Telegram",
      "codeExpires": "Questo codice scade tra 15 minuti e funziona una volta sola.",
      "emailLink": "Inviami il link via email"
    },
    "beliefMap": {
      "untitled": "Argomento senza titolo",
      "roofPlaceholder": "Formulala come un'affermazione che qualcuno potrebbe rifiutare",
      "nameLabel": "Nome",
      "namePlaceholder": "es. Il costo del profilo silenzioso",
      "claimLabel": "Cosa devono credere",
      "claimHint": "Una o due frasi, formulate come qualcosa con cui un lettore attento potrebbe non essere d'accordo.",
      "claimPlaceholder": "Descrivi ciò che il lettore deve arrivare ad accettare",
      "objectionLabel": "Cosa credono invece",
      "objectionHint": "La posizione che questo argomento deve smontare, con le loro parole e nella sua forma più forte. Senza di essa il testo non ha nulla contro cui spingere.",
      "objectionPlaceholder": "es. Pubblicare è vanità - i miei contratti arrivano dal passaparola",
      "add": "Aggiungi un argomento",
      "beliefCount": "nessun argomento | 1 argomento | {count} argomenti",
      "phaseLabel": "Fase del percorso d'acquisto",
      "notFoundTitle": "Questo argomento non esiste",
      "notFoundBody": "Potrebbe essere stata eliminata, oppure il link è sbagliato.",
      "phases": {
        "awareness": {
          "name": "Consapevolezza",
          "question": "È davvero un problema, ed è il mio?",
          "empty": "Ancora nessun argomento per chi non sa ancora di avere questo problema."
        },
        "consideration": {
          "name": "Confronto",
          "question": "Quali opzioni ho, e perché quella ovvia non va bene?",
          "empty": "Ancora nessun argomento per chi sta valutando le opzioni."
        },
        "decision": {
          "name": "Decisione",
          "question": "Posso fidarmi di loro, ed è sicuro muoversi?",
          "empty": "Ancora nessun argomento per chi deve decidere se agire."
        }
      }
    },
    "templates": {
      "loading": "Caricamento dei tuoi modelli",
      "loadError": "Impossibile caricare i tuoi modelli",
      "emptyTitle": "Nessun modello",
      "emptyDescription": "I layout già pronti si raccoglieranno qui, così un post può somigliare al tuo brand senza essere disegnato di nuovo."
    },
    "competitors": {
      "runComparison": "Avvia confronto",
      "runStarted": "Raldo ti confronta di nuovo con i tuoi concorrenti. Può richiedere qualche minuto.",
      "runFailed": "Il confronto non è riuscito",
      "addRival": "Aggiungi un concorrente",
      "atLimitReason": "Stai monitorando il massimo di {max} concorrenti. Smetti di monitorarne uno per aggiungerne un altro.",
      "loadRivalsError": "Impossibile caricare i tuoi concorrenti monitorati",
      "loadReportError": "Impossibile generare il confronto con i concorrenti",
      "emptyNoRivals": {
        "title": "Nessun concorrente ancora monitorato",
        "description": "Monitora il dominio di un concorrente per vedere come ti confronti nella ricerca e nelle risposte dell'IA."
      },
      "emptyNoReport": {
        "title": "Esegui il tuo primo confronto",
        "description": "Raldo confronta i tuoi concorrenti monitorati con il tuo dominio usando dati di ricerca e IA. Può richiedere qualche minuto."
      },
      "emptyDomainUnknown": {
        "title": "Raldo ha prima bisogno del tuo sito",
        "description": "Il confronto con i concorrenti parte dal tuo dominio, che Raldo legge dal tuo sito. Aggiungilo nei dati del tuo marchio.",
        "cta": "Vai ai dati del marchio"
      },
      "status": {
        "notCompared": "Non ancora confrontato",
        "failed": "Confronto non riuscito"
      },
      "figures": {
        "share": "La tua quota di ricerca",
        "shareSub": "Su {count} parola chiave per cui si posizionano i tuoi concorrenti | Su {count} parole chiave per cui si posizionano i tuoi concorrenti",
        "aiShare": "Nominato nelle risposte IA",
        "aiShareSub": "{named} risposta su {answers} ti nomina | {named} risposte su {answers} ti nominano",
        "keywords": "Parole chiave per cui ti posizioni",
        "keywordsSub": "{name} si posiziona per {count}",
        "gaps": "Lacune da colmare",
        "gapsLink": "Vedile in Ricerca",
        "gapsHint": "Parole chiave per cui un concorrente si posiziona e tu no"
      },
      "table": {
        "title": "Tu e i tuoi concorrenti",
        "meta": "Confrontato il {date} · {count} di {max} monitorati",
        "site": "Sito",
        "share": "Quota di ricerca",
        "keywords": "Parole chiave",
        "shared": "In comune",
        "googleAi": "IA di Google",
        "aiAnswers": "Risposte IA",
        "ofCount": "{value} di {count}",
        "hints": {
          "share": "Quota del volume di ricerca per cui competi, pesata per posizione",
          "keywords": "Keyword per cui il sito si posiziona su Google",
          "shared": "Keyword per cui vi posizionate entrambi",
          "googleAi": "Keyword in cui l'AI Overview di Google cita il sito",
          "aiAnswers": "Quota delle risposte IA che nominano una marca monitorata"
        }
      },
      "chart": {
        "title": "Quota di ricerca nel tempo",
        "meta": "A ogni confronto",
        "aria": "Quota di ricerca a ogni confronto, tu contro i tuoi concorrenti"
      },
      "addDialog": {
        "description": "Raldo li confronta con te nella ricerca e nelle risposte dell'IA. Ne monitori {count} su {max}.",
        "field": "Azienda o sito web",
        "placeholder": "Cerca per nome o incolla il loro sito",
        "confirm": "Monitora il concorrente",
        "tracked": "Monitorato",
        "added": "{name} è monitorato. Avvia un confronto per includerlo."
      },
      "addField": {
        "label": "Aggiungi un concorrente",
        "placeholder": "Nome dell'azienda o sito web",
        "hint": "Scrivi il nome di un'azienda o un sito web. Premi Invio per cercare.",
        "search": "Cerca",
        "searching": "Ricerca in corso",
        "noResults": "Nessuna azienda trovata per “{query}”.",
        "tooLong": "Usa al massimo {max} caratteri.",
        "failed": "La ricerca non è riuscita. Riprova.",
        "duplicate": "{name} è già nella lista.",
        "resultsLabel": "Aziende trovate"
      },
      "rival": {
        "trackedSince": "Monitorato dal {date}",
        "positioning": "Il loro posizionamento",
        "openSite": "Apri il sito",
        "stopTracking": "Smetti di monitorare",
        "stopTrackingAria": "Smetti di monitorare {name}",
        "stopTrackingTitle": "Smettere di monitorare {name}?",
        "stopTrackingBody": "Raldo smette di monitorare questo concorrente e il prossimo confronto non lo includerà. Puoi tornare a monitorarlo quando vuoi.",
        "stopTrackingFailed": "Impossibile smettere di monitorare {name}",
        "notFoundTitle": "Concorrente non trovato",
        "notFoundBody": "Potrebbe essere stato rimosso, oppure il link è sbagliato.",
        "back": "Torna ai concorrenti",
        "notComparedTitle": "Non ancora confrontato",
        "notComparedBody": "Raldo non ha ancora confrontato questo concorrente. Avvia un confronto per vedere a che punto sei.",
        "failedTitle": "Impossibile confrontare questo concorrente",
        "failedBody": "L'ultimo confronto non è riuscito per questo sito. Avvialo di nuovo; se continua a non riuscire, controlla l'indirizzo del sito.",
        "figures": {
          "share": "La loro quota di ricerca",
          "yours": "La tua è {value}",
          "visits": "Visite al mese da Google",
          "visitsSub": "Stima",
          "keywords": "Parole chiave per cui si posizionano",
          "keywordsSub": "Tu ti posizioni per {count}",
          "aiShare": "La loro quota di risposte IA"
        },
        "overlap": {
          "title": "Dove le vostre parole chiave si sovrappongono",
          "meta": "{count} parola chiave in tutto | {count} parole chiave in tutto",
          "aria": "{ours} solo tu ti posizioni, {shared} vi posizionate entrambi, {theirs} solo loro si posizionano",
          "ours": "solo tu ti posizioni",
          "shared": "vi posizionate entrambi",
          "theirs": "solo loro si posizionano"
        },
        "winnable": {
          "title": "Parole chiave che puoi strappare loro",
          "meta": "Loro si posizionano, e non è difficile vincere",
          "rank": "La loro posizione",
          "inPlan": "In una pagina del tuo piano",
          "notInPlan": "Non ancora nel tuo piano",
          "emptyTitle": "Ancora nessuna parola chiave da strappare loro"
        },
        "topics": {
          "title": "Posizione per argomento",
          "meta": "Posizione media su Google, più bassa è meglio",
          "topic": "Categoria",
          "theirKeywords": "Le loro parole chiave",
          "theirRank": "La loro posizione media",
          "yourKeywords": "Le tue parole chiave",
          "yourRank": "La tua posizione media",
          "rank": "#{rank}",
          "emptyTitle": "Ancora nessuna posizione per argomento"
        },
        "pages": {
          "title": "Le loro pagine migliori",
          "meta": "Per visite stimate da Google",
          "page": "Pagina",
          "visits": "Visite/mese",
          "keywords": "Parole chiave",
          "emptyTitle": "Ancora nessuna pagina con visite da Google"
        },
        "prompts": {
          "title": "Prompt in cui l'IA nomina {name}",
          "seeAll": "Vedi tutti i prompt",
          "emptyTitle": "Nessuna risposta IA li nomina",
          "emptyBody": "Nessuno dei prompt di questo mese ha spinto ChatGPT o Perplexity a nominarli.",
          "prompt": "Prompt",
          "namedBy": "Nominato da"
        },
        "aiTopics": {
          "title": "{name} nelle risposte IA per argomento",
          "meta": "I prompt che nominano {name} sono esclusi · {period}",
          "topic": "Argomento"
        }
      }
    },
    "company": {
      "loading": "Caricamento del profilo aziendale",
      "loadError": "Impossibile caricare il profilo aziendale",
      "emptyTitle": "Il tuo profilo aziendale non è ancora pronto",
      "emptyDescription": "Completa il setup e Raldo compilerà questa scheda.",
      "editLinksAction": "Modifica i tuoi link"
    },
    "customer": {
      "loading": "Caricamento del tuo profilo cliente",
      "loadError": "Impossibile caricare il tuo profilo cliente",
      "emptyTitle": "Nessun profilo cliente ancora",
      "emptyDescription": "Raldo lo scrive durante il setup. Non è ancora qui."
    },
    "publishing": {
      "title": "Pubblicazione",
      "helper": "L'autore firma ogni pagina e la pagina di prova è dove una pagina manda chi è pronto.",
      "notSet": "Non ancora impostato",
      "notSetAction": "Clicca per aggiungere",
      "urlError": "Inserisci un indirizzo web, ad esempio raldo.ai/trial.",
      "fields": {
        "name": {
          "label": "Nome dell'autore",
          "hint": "Firma ogni pagina.",
          "editTitle": "Modifica il nome dell'autore",
          "placeholder": "Dana Whitfield"
        },
        "role": {
          "label": "Ruolo",
          "hint": "Appare sotto il nome.",
          "editTitle": "Modifica il ruolo",
          "placeholder": "Head of Growth"
        },
        "bio": {
          "label": "Bio in una riga",
          "hint": "Una riga su chi è.",
          "editTitle": "Modifica la bio",
          "placeholder": "Scrive di come rilasciare software senza drammi."
        },
        "profileUrl": {
          "label": "URL del profilo",
          "hint": "Dove chi legge trova l'autore.",
          "editTitle": "Modifica l'URL del profilo",
          "placeholder": "linkedin.com/in/dana-whitfield"
        },
        "trialUrl": {
          "label": "Pagina di prova o demo",
          "hint": "Dove una pagina manda chi è pronto.",
          "editTitle": "Modifica la pagina di prova o demo",
          "placeholder": "raldo.ai/trial"
        }
      }
    }
  },
  "media": {
    "formatSquare": "Quadrato (1:1)",
    "designOfPost": "Post · {title}",
    "freeDesign": "Design libero",
    "formatPortrait": "Verticale (4:5)",
    "formatStory": "Storia (9:16)",
    "uploads": "Caricamenti",
    "designs": "Design",
    "newDesignTitle": "Nuovo design",
    "newDesignDescription": "Scegli un formato e parti da una tela vuota.",
    "newUploadTitle": "Carica contenuti",
    "newUploadDescription": "Porta qui le immagini dal tuo dispositivo.",
    "templates": "Modelli",
    "templatesEmptyTitle": "Ancora nessuno stile del brand",
    "templatesEmptyDescription": "Apri un design e scegli Crea stile del brand per trasformarlo nei 16 layout del tuo brand.",
    "upload": "Carica",
    "create": "Crea",
    "typeAriaLabel": "Tipo di media",
    "loading": "Caricamento della libreria multimediale in corso",
    "loadError": "Impossibile caricare la libreria multimediale",
    "emptyTitle": "La tua libreria multimediale è vuota",
    "emptyDescription": "Le immagini caricate e i modelli salvati si accumuleranno qui.",
    "designsLoading": "Caricamento dei tuoi design in corso",
    "designsLoadError": "Impossibile caricare i tuoi design",
    "designsEmptyTitle": "Ancora nessun design",
    "designsEmptyDescription": "Raldo crea i design in chat - chiedine uno lì e comparirà qui.",
    "designsEmptyAction": "Apri la chat",
    "deleteUploadTitle": "Eliminare {filename}?",
    "deleteUploadBody": "Questo rimuove definitivamente il file dalla tua libreria.",
    "deleteDesignTitle": "Eliminare {name}?",
    "deleteDesignBody": "Questo rimuove definitivamente il design e le sue pagine.",
    "createFromTemplateTitle": "Creare un design da \"{name}\"?",
    "createFromTemplateBody": "Questo aggiunge un nuovo design al tuo brand, a partire da questo modello.",
    "createDesignCta": "Crea design",
    "draftingToast": "Raldo sta scrivendo la bozza del tuo post.",
    "untitledDesignName": "Design senza titolo",
    "toast": {
      "createDesignFailed": "Impossibile creare questo design",
      "renameDesignFailed": "Impossibile rinominare questo design",
      "duplicateDesignFailed": "Impossibile duplicare questo design",
      "deleteDesignFailed": "Impossibile eliminare questo design",
      "saveDesignFailed": "Impossibile salvare questo design",
      "uploadFailed": "Impossibile caricare questo file",
      "deleteFileFailed": "Impossibile eliminare questo file"
    },
    "uploadError": {
      "contentTypeNotAllowed": "Questo tipo di file non è supportato. Carica un'immagine JPEG, PNG, GIF o WebP.",
      "fileTooLarge": "Questo file è troppo grande. La dimensione massima è 8 MB.",
      "storageQuotaExceeded": "Questo brand ha raggiunto il limite di spazio di archiviazione.",
      "unreadableImage": "Non siamo riusciti a leggere questa immagine. Prova con un altro file.",
      "uploadNotFound": "Questo caricamento non è stato trovato. Prova a caricarlo di nuovo.",
      "fallback": "Si è verificato un problema durante il caricamento del file. Riprova."
    },
    "quickLook": {
      "dimensions": "Dimensioni",
      "pixels": "{width} x {height} px",
      "size": "Dimensione del file",
      "type": "Tipo",
      "added": "Aggiunto",
      "useInDesign": "Usa in un design"
    },
    "brandStyle": {
      "title": "Stile del brand",
      "inUse": "In uso",
      "fromDesign": "Da {design}",
      "newTitle": "Nuovo stile del brand",
      "building": "Creazione dei 16 layout · {done} di {total}",
      "ready": "Pronto da controllare",
      "loading": "Caricamento dello stile del brand",
      "loadError": "Impossibile caricare lo stile del brand"
    },
    "designMaking": "Raldo sta creando questo design",
    "designMakingTitle": "Questo design è ancora in creazione",
    "designMakingBody": "Raldo sta ancora creando questo design. Potrai aprirlo quando sarà pronto. Riceverai un messaggio nella posta in arrivo.",
    "designMakingConfirm": "Ho capito"
  },
  "content": {
    "status": {
      "draft": "Bozza",
      "pendingHandoff": "In attesa della grafica",
      "scheduled": "Programmato",
      "published": "Pubblicato",
      "failed": "Non riuscito",
      "pendingHandoffCaption": "In attesa della grafica prima della pubblicazione."
    },
    "seeFullPost": "Vedi il post completo",
    "minimize": "Riduci a icona",
    "setDateTime": "Imposta data e ora",
    "notScheduled": "Non programmato",
    "noDateYet": "Nessuna data ancora",
    "untitledPost": "Post senza titolo",
    "schedule": "Programma",
    "reschedule": "Riprogramma",
    "unschedule": "Annulla programmazione",
    "cancel": "Annulla",
    "publishNow": "Pubblica ora",
    "duplicate": "Duplica",
    "tryAgain": "Riprova",
    "correct": "Correggi",
    "removeAttachment": "Rimuovi",
    "replace": "Sostituisci",
    "openOnLinkedIn": "Apri su LinkedIn",
    "actionForTitleAria": "{action}: {title}",
    "canvasLabel": "Canvas",
    "createDesign": "Crea design",
    "templateBadge": "Modello",
    "brandBadge": "Marchio",
    "editAttachment": "Modifica allegato",
    "resultsLabel": "Risultati",
    "copyLabel": "Testo",
    "writePostCopyPlaceholder": "Scrivi il testo del post…",
    "frame": {
      "selectAria": "Seleziona {title}",
      "plannedDateAria": "Imposta data e ora pianificate"
    },
    "peek": {
      "closeDetails": "Chiudi dettagli",
      "editCopyAria": "Modifica il testo di {title}"
    },
    "write": {
      "saving": "Salvataggio…",
      "saved": "Salvato",
      "scheduleEmptyHint": "Scrivi qualcosa prima di programmare questo post.",
      "schedule": {
        "nextSlot": "Prossimo slot libero: {date}",
        "noCadence": "Questo brand non ha ancora una cadenza di pubblicazione impostata, quindi Raldo non può suggerire uno slot.",
        "noOpenSlot": "Tutti gli slot della cadenza di pubblicazione sono già occupati.",
        "pickAnotherDate": "Scegli un'altra data",
        "loadingAria": "Ricerca del prossimo slot libero"
      },
      "readability": {
        "tooltip": {
          "title": "Scala di leggibilità",
          "veryEasy": "9-10 · molto facile - libri per bambini",
          "easy": "7-8 · facile - narrativa, copy di marketing efficace",
          "standard": "5-6 · standard - quotidiani",
          "dense": "3-4 · denso - documenti ufficiali",
          "difficult": "1-2 · difficile - testi accademici",
          "footnote": "Circa 1 adulto su 5 legge al livello di alfabetizzazione più basso. Un testo a 6/10 o più resta leggibile per quasi tutti."
        }
      }
    },
    "post": {
      "unscheduled": "Non pianificato",
      "mediaLabel": "Media",
      "noMediaAttached": "Nessun media allegato",
      "askPlaceholder": "Chiedi a Raldo di modificare questo post…",
      "attachDesign": "Allega un design",
      "designHint": "Raldo può creare i media dalle slide del post, oppure puoi allegare un design che hai già.",
      "openDesign": "Apri il design",
      "designMedia": "Crea i media",
      "designMediaFailed": "Impossibile avviare il design",
      "designMediaRefused": {
        "noMedia": "Questo post non ha ancora slide da trasformare in design.",
        "notDesignable": "Solo una bozza o un post non riuscito senza design può riceverne uno nuovo.",
        "running": "Raldo sta già creando il design di questo post.",
        "editorRole": "Solo un editor può creare il design dei contenuti."
      },
      "run": {
        "working": "Raldo sta scrivendo un post.",
        "stages": {
          "brief": "Raldo sceglie l'argomento, il tema e i punti.",
          "write": "Raldo scrive la caption e le slide.",
          "check": "Raldo controlla il post."
        },
        "completed": "Il post è scritto.",
        "partial": "Il post è scritto, ma un passaggio non è finito.",
        "cancelled": "Hai fermato il post.",
        "failed": "Il post si è fermato"
      },
      "slides": "Slide",
      "slide": "Slide {n}",
      "score": "Punteggio {score} su 100",
      "needsPerson": "Serve una persona",
      "ready": "Pronto",
      "readability": "Leggibilità",
      "fromPage": "Dalla pagina",
      "madeFrom": "Creato da",
      "addDesign": "Aggiungi un design",
      "editDesign": "Modifica il design",
      "viewDesign": "Guarda il design",
      "letRaldoDesign": "Lascia che Raldo lo progetti",
      "needsSlides": "Servono le slide. Questo post non ne ha ancora.",
      "start": {
        "title": "Inizia",
        "letRaldoWrite": "Lascia che Raldo lo scriva",
        "orWrite": "Oppure scrivilo tu. Il post si salva alla prima parola.",
        "whichArgument": "Quale argomento deve sostenere il post?",
        "letRaldoChoose": "Lascia scegliere a Raldo",
        "fromBeliefMap": "Dalla tua mappa delle convinzioni e dalla ricerca"
      }
    },
    "artwork": {
      "groupAria": "Grafica del post",
      "loading": "Caricamento della grafica in corso",
      "loadError": "Questa pagina non è stata caricata",
      "pageAlt": "Pagina {page}",
      "previousPage": "Pagina precedente",
      "nextPage": "Pagina successiva",
      "goToPage": "Vai alla pagina {page}",
      "pageStatus": "Pagina {page} di {count}"
    },
    "designPicker": {
      "title": "Allega un design",
      "description": "Scegli un design terminato da usare come grafica per questo post.",
      "loading": "Caricamento dei tuoi design in corso",
      "emptyTitle": "Nessun design ancora pronto",
      "emptyDescription": "Raldo crea i design in chat - chiedine uno lì e comparirà qui non appena sarà pronto."
    },
    "workspace": {
      "defaultAuthorName": "Il tuo brand",
      "linkedinPublicMeta": "LinkedIn · Pubblico",
      "weekOf": "Settimana del {date}",
      "unscheduledColumn": "Non programmati",
      "scheduleReadyCount": "Programma 1 post | Programma {count} post",
      "canvasEmptyTitle": "Ancora niente da rivedere",
      "canvasEmptyDescription": "Quando ci saranno bozze o post programmati, li vedrai qui, uno accanto all'altro.",
      "untitledArticle": "Pagina senza titolo",
      "articlePlanning": "Raldo sta pianificando questa pagina…",
      "articleWriting": "Raldo sta scrivendo questa pagina…",
      "scheduleGenerating": "Raldo sta scrivendo…"
    },
    "previousPeriod": "Periodo precedente",
    "nextPeriod": "Periodo successivo",
    "calendar": {
      "week": "Settimana",
      "month": "Mese",
      "today": "Oggi",
      "viewAria": "Vista calendario",
      "articlesLane": "Pagine",
      "articleBadge": "Pagina",
      "articleOpen": "Apri la pagina",
      "articleQuestion": "Risponde a · {question}",
      "articleTopic": "Tema · {name}",
      "articleWords": "1 parola | {count} parole",
      "articleSections": "1 sezione | {count} sezioni",
      "articleStats": "{words} · {sections}",
      "kindAll": "Tutti",
      "kindArticles": "Pagine",
      "kindPosts": "Post",
      "kindAria": "Filtra per tipo"
    },
    "metrics": {
      "clicks": "Clic",
      "engagement": "Engagement"
    },
    "results": {
      "noneYet": "Non è stato ancora registrato nulla.",
      "notLive": "I risultati compaiono qui quando il post è online su LinkedIn."
    },
    "deleteAssetAria": "Elimina asset",
    "postMediaAria": "Media del post",
    "preview": {
      "mediaError": "Impossibile caricare questo design",
      "croppedByFeed": "Il feed ritaglierà questo design",
      "device": {
        "ariaLabel": "Dispositivo di anteprima",
        "desktop": "Desktop",
        "tablet": "Tablet",
        "mobile": "Mobile"
      }
    },
    "loadingPlan": "Caricamento del piano dei contenuti in corso",
    "loadPlanError": "Impossibile caricare il piano dei contenuti",
    "talkToRaldo": "Parla con Raldo",
    "deleteDialog": {
      "title": "Eliminare questo post?",
      "description": "Questo elimina definitivamente il post e tutta la sua cronologia delle versioni. Non può essere annullato."
    },
    "publishDialog": {
      "title": "Pubblicare subito questo post?",
      "description": "Questo pubblica subito il post su LinkedIn e non può essere annullato tramite Raldo. L'unico modo per tornare indietro è eliminarlo, il che distrugge il post e tutte le interazioni ricevute."
    },
    "scheduleReadyDialog": {
      "title": "Programmare tutto ciò che è pronto?",
      "description": "Questo programma 1 post per la pubblicazione. | Questo programma {count} post per la pubblicazione."
    },
    "removeArtworkDialog": {
      "title": "Rimuovere questo artwork?",
      "description": "Il post mantiene il suo testo e la sua programmazione; il design in sé non viene eliminato."
    },
    "toast": {
      "saveEditFailed": "Impossibile salvare questa modifica",
      "restoreFailed": "Impossibile ripristinare questa versione",
      "scheduleFailed": "Impossibile programmare questo post",
      "publishFailed": "Impossibile pubblicare questo post",
      "rescheduleFailed": "Impossibile riprogrammare questo post",
      "setPublishAtFailed": "Impossibile spostare la data di questo post",
      "cancelScheduleFailed": "Impossibile annullare questa programmazione",
      "deleteFailed": "Impossibile eliminare questo post",
      "schedulePeriodFailed": "Impossibile programmare questi post",
      "createFailed": "Impossibile creare questo post",
      "attachDesignFailed": "Impossibile allegare questo design",
      "nextSlotFailed": "Impossibile trovare il prossimo slot libero",
      "editArticleMetaFailed": "Impossibile salvare questa modifica",
      "attachPublishedUrlFailed": "Impossibile salvare questo indirizzo",
      "promoteArticleFailed": "Impossibile promuovere questa pagina",
      "promoteArticleNotVerified": "L'indirizzo di questa pagina non è ancora verificato. Potrai promuoverla una volta confermato il suo URL live.",
      "recheckArticleHealthFailed": "Impossibile controllare la pagina online",
      "exportArticleFailed": "Impossibile esportare questa pagina",
      "writePostFailed": "Impossibile avviare il post"
    },
    "renderGate": {
      "preparing": "Preparazione dell'artwork per \"{post}\" - {current} di {total}",
      "preparingBulk": "Preparazione dell'artwork - {current} di {total} post",
      "failedTitle": "Impossibile preparare l'artwork",
      "failedDescription": "Non è stato possibile renderizzare il design di \"{post}\". Riprova.",
      "missingRenderMessage": "L'artwork di questo post non era pronto. Riprova e Raldo lo preparerà prima."
    },
    "draftConflict": {
      "message": "Raldo ha riscritto questo post. Hai modifiche non salvate - scegli quale versione tenere.",
      "compare": "Confronta",
      "hideCompare": "Nascondi confronto",
      "keepMine": "Tieni le mie",
      "useRaldos": "Usa quella di Raldo"
    },
    "shapeFilter": {
      "all": "Tutti",
      "posts": "Post",
      "articles": "Pagine",
      "aria": "Filtra per tipo"
    },
    "create": {
      "button": "Crea contenuto",
      "page": {
        "title": "Quale pagina deve scrivere?",
        "description": "Scegli una pagina pianificata. Raldo scrive il testo che risponde alla sua domanda.",
        "confirm": "Scrivila",
        "label": "Pagina",
        "placeholder": "Cerca tra le pagine pianificate",
        "next": "Prossima",
        "emptyTitle": "Nessuna pagina da scrivere",
        "emptyBody": "Ogni pagina pianificata ha una bozza, oppure il piano non è ancora stato eseguito."
      },
      "newPost": "Nuovo post",
      "newPage": "Nuova pagina"
    },
    "topics": {
      "removeTitle": "Rimuovere questa categoria?",
      "removeBody": "Questo rimuove la categoria definitivamente.",
      "add": "Aggiungi una categoria",
      "covers": "Cosa copre",
      "remove": "Rimuovi categoria",
      "untitled": "Categoria senza titolo",
      "newTopic": "Nuova categoria",
      "editTitle": "Modifica categoria"
    },
    "keywords": {
      "cells": {
        "notMeasured": "Non misurato",
        "notRanking": "Non in classifica"
      }
    },
    "inspector": {
      "reasons": {
        "link": "Contiene un link",
        "unsupportedFigure": "Un numero non ha una fonte",
        "hookLength": "L'apertura è troppo lunga",
        "bodyLength": "Il testo è troppo lungo",
        "captionLength": "Il post è troppo lungo",
        "ctaLines": "La call to action supera una riga",
        "slideLayout": "Il layout delle slide non torna",
        "slideTextLength": "Il testo di una slide è troppo lungo",
        "slideParts": "Una slide ha parti sbagliate",
        "slideFigure": "Un numero in una slide è sbagliato",
        "slideQuote": "Una citazione non corrisponde alla fonte",
        "slideHighlight": "Un'evidenziazione è sbagliata",
        "slideImages": "Troppe idee per le immagini",
        "avoidedWord": "Usa una parola da evitare",
        "termForm": "Un nome è scritto male",
        "aiTell": "Sembra scritto da un'IA",
        "bannedStructure": "Usa una formulazione vietata",
        "markdown": "Contiene simboli markdown",
        "hashtags": "Numero di hashtag sbagliato",
        "proof": "Nessuna prova per la tesi",
        "phase": "Fase d'acquisto sbagliata",
        "beliefLink": "Non sostiene il punto",
        "generic": "Raldo ha segnalato una regola"
      },
      "beforePublish": "Prima di pubblicare",
      "history": "Cronologia",
      "argues": "Sostiene",
      "stage": "Fase · {name}",
      "topic": "Argomento",
      "standsOn": "Si basa su",
      "sources": "{count} fonte | {count} fonti",
      "asksReaders": "Invita i lettori a",
      "changedAfterCheck": "Hai modificato il testo dopo il controllo di Raldo.",
      "notChecked": "Raldo non ha controllato questo post.",
      "argument": "Argomentazione",
      "argumentLine": "L'argomentazione che questo post sostiene.",
      "claim": "Tesi",
      "openArgument": "Apri l'argomentazione",
      "standsOnLine": "I fatti nel post e chi li ha detti.",
      "cta": {
        "toMedia": "Guarda le slide",
        "comment": "Commenta",
        "save": "Salva il post",
        "article": "Leggi l'articolo",
        "demo": "Prenota una demo"
      },
      "bar": {
        "words": "{count} parole",
        "hashtags": "{count} hashtag",
        "characters": "{count} / {limit} caratteri",
        "readability": "Leggibilità {score}/10",
        "lengthAria": "Sulla lunghezza",
        "lengthTitle": "Lunghezza",
        "lengthOptimal": "L'ideale sono circa {count} parole per {channel}",
        "lengthVisible": "I primi {count} caratteri compaiono prima di «altro»",
        "lengthNote": "Una guida, non un limite."
      },
      "brief": "Brief"
    },
    "newPost": "Nuovo post"
  },
  "strategy": {
    "keyword": {
      "standing": {
        "page1": "Pagina 1 di Google · #{rank}",
        "below": "Oltre la pagina 1 di Google · #{rank}",
        "rank": "#{rank}",
        "notRanking": "Non in classifica su Google"
      },
      "figures": {
        "searches": "Ricerche al mese",
        "onGoogle": "Su Google",
        "notMeasured": "Non ancora misurato",
        "competition": "Difficoltà",
        "competitionScore": "{score} su 100",
        "firstRank": "#{rank} il {date}",
        "rank": "La tua posizione su Google",
        "page1": "Pagina 1",
        "below": "Oltre la pagina 1",
        "notRankingYet": "Non ancora in classifica",
        "ai": "Google AI Overview",
        "notChecked": "Non ancora verificata",
        "noAnswer": "Non c'è una risposta IA",
        "rivalCited": "È citato un concorrente",
        "citesOthers": "La risposta cita altri",
        "rivalsToo": "È citato anche un concorrente | Sono citati anche {count} concorrenti",
        "noRival": "E nessun concorrente",
        "cited": "Citata",
        "notCited": "Non citata"
      },
      "stats": {
        "published": "pubblicate",
        "drafting": "in bozza",
        "noContent": "ancora senza contenuti",
        "page1": "in pagina 1",
        "below": "oltre la pagina 1",
        "rankRest": "non in classifica o non ancora misurate",
        "citeYou": "ti citano",
        "withoutYou": "rispondono senza di te",
        "aiRest": "senza risposta IA",
        "covered": "Keyword per cui hai contenuti",
        "ranking": "Keyword per cui sei in pagina 1 su Google",
        "cited": "Keyword per cui le risposte IA ti citano"
      },
      "citations": {
        "cited": "Citato",
        "notCited": "Non citato",
        "columns": {
          "site": "Sito",
          "answer": "Nella risposta"
        }
      },
      "rankHistory": {
        "aria": "Posizione nella ricerca nelle ultime {count} settimane, da #{from} a #{to}",
        "threshold": "Pagina 1"
      },
      "difficultyScore": {
        "low": "Difficoltà bassa, {score} su 100",
        "medium": "Difficoltà media, {score} su 100",
        "high": "Difficoltà alta, {score} su 100"
      },
      "difficulty": {
        "low": "Bassa",
        "medium": "Media",
        "high": "Alta"
      },
      "rankings": {
        "visits": "{visits} visita/mese | {visits} visite/mese",
        "none": "Né tu né un rivale che segui siete in classifica per questa keyword.",
        "columns": {
          "rank": "Posizione",
          "site": "Sito",
          "page": "Pagina che si posiziona",
          "visits": "Visite al mese"
        }
      },
      "volumeHistory": {
        "aria": "Ricerche al mese, da {from} a {to}: da {first} a {last}"
      },
      "site": {
        "you": "Tu"
      }
    },
    "keywords": {
      "columns": {
        "keyword": "Keyword",
        "stage": "Fase",
        "volume": "Volume/mese",
        "difficulty": "Difficoltà",
        "searchRank": "Posizione nella ricerca",
        "aiOverview": "Citata in AI Overview"
      }
    },
    "schedule": {
      "days": "Giorni",
      "off": "Disattivato",
      "maxDays": "Al massimo {count} giorni a settimana",
      "unsavedChanges": "Il tuo calendario di pubblicazione ha modifiche non salvate."
    },
    "coreMessage": {
      "caption": "Il tuo messaggio chiave",
      "editTitle": "Modifica messaggio chiave"
    },
    "argument": {
      "open": "Apri l'argomento: {subject}"
    },
    "noContent": "Ancora nessun contenuto",
    "pieces": {
      "count": "{count} contenuti | {count} contenuto | {count} contenuti",
      "list": "{title}: {count} contenuti | {title}: {count} contenuto | {title}: {count} contenuti",
      "seeAll": "Vedi tutti i {count} contenuti",
      "seeAllCount": "Vedi tutti i {count}",
      "linkedinPost": "Post LinkedIn",
      "published": "Pubblicato il {date}",
      "scheduled": "Programmato per il {date}",
      "draft": "Bozza"
    },
    "journeyStage": "Fase del percorso",
    "addArgument": "Aggiungi argomento",
    "balance": {
      "caption": "Distribuzione dei contenuti per fase del percorso d'acquisto",
      "window": "Ultimi 90 giorni",
      "aria": "Quota di contenuti per fase del percorso"
    },
    "argumentPage": {
      "editTitle": "Modifica argomento",
      "crumb": "Argomento: {stage}",
      "back": "Torna alla Strategia",
      "remove": "Rimuovi argomento",
      "removeTitle": "Rimuovere questo argomento?",
      "removeBody": "L'argomento viene rimosso per sempre.",
      "content": "Contenuti",
      "posts": "{count} post | {count} post | {count} post",
      "articles": "{count} pagine | {count} pagina | {count} pagine",
      "postsAndArticles": "{posts} e {articles}",
      "groups": {
        "published": "Pubblicati",
        "scheduled": "Programmati",
        "drafts": "Bozze"
      },
      "noContentTitle": "Ancora nessun contenuto sostiene questo argomento",
      "noContentBody": "Pianifica una pagina o un post e Raldo ne scrive la bozza a partire da questo argomento."
    },
    "topicPage": {
      "distributionAria": "Quota dei contenuti di questo tema per fase del percorso",
      "stageArguments": "Argomenti nella fase {stage}",
      "argumentCount": "{count} argomenti | {count} argomento | {count} argomenti",
      "noneCarried": "Ancora nessun argomento nei contenuti",
      "nothingAtStage": "In questo tema niente sostiene ancora la fase {stage}.",
      "piecesInTopic": "{count} contenuti in questo tema | {count} contenuto in questo tema | {count} contenuti in questo tema",
      "notFoundTitle": "Questo tema non esiste",
      "notFoundBody": "Potrebbe essere stato eliminato, oppure il link è sbagliato.",
      "missing": "Questo tema non esiste più.",
      "tabsAria": "Sezioni del tema"
    },
    "pages": {
      "groups": {
        "explainer": "Pagina esplicativa",
        "offer": "Pagine prodotto",
        "comparison": "Pagine di confronto",
        "use-case": "Pagine caso d'uso",
        "supporting": "Pagine di supporto"
      },
      "types": {
        "explainer": "Pagina esplicativa",
        "offer": "Pagina prodotto",
        "comparison": "Pagina di confronto",
        "use-case": "Pagina caso d'uso",
        "supporting": "Pagina di supporto"
      }
    },
    "citations": {
      "none": "Nessuno",
      "ownCited": "Tu, citato",
      "ownNamed": "Ti nomina, senza link",
      "rivalCited": "{name}, citato"
    },
    "stageField": {
      "notPlaced": "Non ancora collocata in una fase",
      "notPlacedHint": "Modificala per scegliere la fase."
    },
    "plan": {
      "start": "Pianifica le pagine",
      "emptyTitle": "Ancora nessun piano",
      "emptyBody": "Raldo elenca ogni pagina del tuo sito e controlla come si posiziona nella ricerca.",
      "stale": {
        "title": "La strategia è cambiata dopo questo piano",
        "body": "Pianifica di nuovo le pagine, così il piano segue la tua strategia attuale."
      },
      "proposal": {
        "summary": {
          "nothing": "Il nuovo piano non cambia nulla nel tuo piano attuale.",
          "pagesAdded": "{count} pagina aggiunta | {count} pagine aggiunte",
          "pagesRemoved": "{count} pagina rimossa | {count} pagine rimosse",
          "pagesChanged": "{count} pagina modificata | {count} pagine modificate",
          "pagesKept": "{count} pagina scritta resta | {count} pagine scritte restano",
          "topicsAdded": "{count} tema aggiunto | {count} temi aggiunti",
          "topicsRemoved": "{count} tema rimosso | {count} temi rimossi",
          "topicsRenamed": "{count} tema rinominato | {count} temi rinominati"
        },
        "accept": "Accetta",
        "startBlocked": "Prima accetta o scarta il nuovo piano.",
        "discardConfirm": {
          "title": "Scartare il nuovo piano?",
          "body": "Il tuo piano attuale resta com'è. Puoi pianificare di nuovo le pagine più tardi."
        },
        "refusals": {
          "ownerAdminRequired": "Solo un titolare o un admin può cambiare il piano.",
          "gateMissing": "Questo passaggio non aspetta più te.",
          "answerInvalid": "Gli argomenti che hai tenuto non corrispondono più alla proposta. Ricarica e riprova."
        }
      },
      "run": {
        "working": "Raldo sta pianificando le tue pagine.",
        "waiting": "Il nuovo piano aspetta la tua revisione.",
        "stages": {
          "inventory": "Raldo sta elencando le pagine del tuo sito.",
          "content": "Raldo sta leggendo le tue pagine.",
          "research": "Raldo sta trovando i nomi che usano i tuoi clienti.",
          "competitors": "Raldo sta leggendo per cosa si posizionano i tuoi concorrenti.",
          "demand": "Raldo sta misurando quanto spesso viene cercato ogni termine.",
          "relevance": "Raldo sta valutando le ricerche per la tua azienda.",
          "topic-candidates": "Raldo sta proponendo i temi.",
          "review-topics": "I temi aspettano la tua revisione.",
          "fill": "Raldo sta approfondendo il tema che hai aggiunto.",
          "serp": "Raldo sta leggendo i risultati di ricerca di ogni ricerca.",
          "grouping": "Raldo sta raggruppando le ricerche in pagine.",
          "type-stage": "Raldo sta decidendo a cosa serve ogni pagina.",
          "placement": "Raldo sta collocando ogni pagina sotto un tema.",
          "decision-pages": "Raldo sta aggiungendo le pagine che i clienti leggono prima di scegliere.",
          "site-match": "Raldo sta confrontando il piano con le pagine del tuo sito.",
          "review-plan": "Il piano aspetta la tua revisione.",
          "commit": "Raldo sta scrivendo il piano."
        },
        "completed": "Il piano è pronto.",
        "partial": "Il piano è pronto, ma alcuni passaggi non sono stati completati.",
        "cancelled": "Hai annullato il piano.",
        "failed": "Il piano si è fermato",
        "startDescription": "Raldo pianifica prima i tuoi temi, poi le pagine. Tu li rivedi entrambi.",
        "direction": "Direzione",
        "directionHint": "Una riga che Raldo tiene a mente mentre pianifica.",
        "directionPlaceholder": "Per esempio: concentrati sui motori di risposta",
        "market": "Mercato",
        "planWithDirection": "Pianifica con una direzione"
      },
      "figures": {
        "notMeasured": "Non ancora misurato"
      },
      "topics": {
        "pages": "Pagine",
        "writingOrder": "In ordine di scrittura",
        "pageCount": "{count} pagina | {count} pagine",
        "progress": "{count} di {total} pagine scritte, online o sul tuo sito",
        "pagesDone": "{count} di {total} pagine",
        "statusCounts": {
          "planned": "{count} pianificata | {count} pianificate",
          "writing": "{count} in scrittura",
          "live": "{count} online",
          "site": "{count} sul tuo sito"
        }
      },
      "page": {
        "hub": "Pagina hub",
        "searchesAMonth": "{volume} ricerche al mese",
        "writeNext": "Da scrivere ora",
        "comparesWith": "Confronta con {name}",
        "searches": "Ricerche a cui risponde",
        "columns": {
          "search": "Ricerca",
          "role": "Ruolo",
          "volume": "Ricerche al mese"
        },
        "roles": {
          "main": "Principale",
          "secondary": "Secondaria"
        },
        "updates": "Aggiorna una pagina del tuo sito",
        "noArticleTitle": "Ancora nessuna bozza",
        "noArticleBody": "Raldo scrive il testo che risponde a questa domanda, dai tuoi argomenti e dalle tue fonti.",
        "notFoundTitle": "Questa pagina non esiste",
        "notFoundBody": "Potrebbe essere stata eliminata, oppure il link è sbagliato.",
        "write": "Scrivi pagina",
        "run": {
          "working": "Raldo sta scrivendo questa pagina.",
          "stages": {
            "sources": "Raldo sta leggendo le pagine che si posizionano per questa domanda.",
            "scope": "Raldo sta ordinando ciò che dicono le pagine nei temi di questa pagina.",
            "trace": "Raldo sta risalendo alla fonte originale di ogni fatto.",
            "evidence": "Raldo sta leggendo le tue pagine per ciò che puoi mostrare in prima persona.",
            "gain": "Raldo sta cercando cosa può aggiungere questa pagina.",
            "argument": "Raldo sta scegliendo l'argomento di questa pagina.",
            "plan": "Raldo sta pianificando la pagina.",
            "draft": "Raldo sta scrivendo la bozza della pagina.",
            "edit": "Raldo sta rivedendo la pagina.",
            "check": "Raldo sta controllando la pagina.",
            "handoff": "Raldo sta preparando la pagina per il tuo sito."
          },
          "completed": "La pagina è scritta.",
          "partial": "La pagina è scritta, ma alcuni passi non sono finiti.",
          "cancelled": "Hai annullato la pagina.",
          "failed": "La pagina si è fermata",
          "waiting": "Raldo ha domande per te. Rispondi o saltale e la pagina va avanti."
        },
        "research": {
          "title": "Ricerca",
          "sources": "{read} pagine lette su {found}",
          "statements": "affermazioni delle pagine",
          "items": "{items} temi",
          "points": "punti, formato {format}",
          "noFormat": "non impostato",
          "facts": "{facts} fatti",
          "traced": "ricondotti alla fonte, {waiting} in attesa",
          "ownPages": "{pages} tue pagine",
          "evidence": "prove, {items} temi con prove"
        },
        "argumentCarriedBy": "Portato da {item}",
        "gains": {
          "kinds": {
            "disagreement": "Le fonti non concordano",
            "gap": "Lacuna",
            "ai-answers": "Risposte IA",
            "brand": "Da te"
          }
        },
        "questions": {
          "title": "Domande per te",
          "open": "{count} aperta | {count} aperte",
          "hint": "Cosa aiuta: {hint}",
          "without": "Senza: {without}",
          "placeholder": "Scrivi qui la tua risposta",
          "answer": "Rispondi",
          "skip": "Salta",
          "skipped": "Saltata"
        },
        "hubOf": "Hub di {topic}",
        "fault": {
          "title": "Raldo non è riuscito a leggere la pagina online",
          "body": "Raldo ha controllato {address} il {date}. La pagina conta come online quando un controllo va a buon fine.",
          "bodyUndated": "Raldo ha controllato {address}. La pagina conta come online quando un controllo va a buon fine."
        },
        "noArticleRunning": "Raldo lo scrive quando la ricerca è finita.",
        "noArticleSite": "Questa pagina è già sul tuo sito.",
        "noSearchesTitle": "Nessuna ricerca per questa pagina",
        "noSearchesBody": "Questa pagina porta un argomento, non una ricerca. La sua portata è in Visibilità, Risposte IA."
      },
      "status": {
        "planned": "Pianificata",
        "writing": "In scrittura",
        "live": "Online",
        "site": "Sul tuo sito"
      },
      "argument": {
        "underTopic": "Sostenuto nel tema",
        "pages": "Pagine che lo sostengono",
        "pageCount": "{count} pagina | {count} pagine"
      },
      "overview": {
        "pagesByStage": "{count} pagina | {count} pagine",
        "caption": "Pagine pianificate per fase del percorso d'acquisto",
        "ariaLabel": "Quota di pagine pianificate per fase del percorso"
      },
      "setup": {
        "title": "Il tuo piano",
        "startsWith": "Inizia con: {question}"
      },
      "stops": {
        "aria": "Passaggi della pianificazione",
        "titles": {
          "find-topics": "Trova i temi",
          "review-topics": "Rivedi i temi",
          "plan-pages": "Pianifica le pagine",
          "review-plan": "Rivedi il piano"
        },
        "stepOf": "Passaggio {n} di {total}",
        "done": "Fatto",
        "waitsForYou": "Aspetta te",
        "yourReview": "La tua revisione",
        "steps": "{count} passaggio | {count} passaggi"
      },
      "step": {
        "titles": {
          "inventory": "Pagine del sito",
          "content": "Contenuto delle pagine",
          "research": "Ricerca",
          "competitors": "Concorrenti",
          "demand": "Domanda",
          "relevance": "Pertinenza",
          "topic-candidates": "Temi proposti",
          "review-topics": "Rivedi i temi",
          "fill": "Completa i nuovi temi",
          "serp": "Risultati di ricerca",
          "grouping": "Pagine",
          "type-stage": "Tipi di pagina",
          "placement": "Collocazione",
          "decision-pages": "Pagine di decisione",
          "site-match": "Confronto con il sito",
          "review-plan": "Rivedi il piano",
          "commit": "Scrivi il piano"
        },
        "summaries": {
          "inventory": "{count} pagina sul tuo sito | {count} pagine sul tuo sito",
          "content": "{count} pagina letta | {count} pagine lette",
          "research": "{terms} termini per {coverage} ambiti",
          "competitors": "{competitors} concorrenti · {searches} ricerche",
          "demand": "{count} ricerca misurata | {count} ricerche misurate",
          "relevance": "{kept} di {units} ricerche tenute",
          "topic-candidates": "{count} tema proposto | {count} temi proposti",
          "review-topics": "{count} tema approvato | {count} temi approvati",
          "fill": "Nessun tema da approfondire | {count} tema approfondito | {count} temi approfonditi",
          "serp": "{count} ricerca letta | {count} ricerche lette",
          "grouping": "{pages} pagine da {keywords} ricerche",
          "type-stage": "{kept} di {pages} pagine tenute",
          "placement": "{pages} pagine sotto {topics} temi",
          "decision-pages": "{count} pagina di decisione | {count} pagine di decisione",
          "site-match": "{planned} pagine · {update} aggiornano una pagina del tuo sito",
          "review-plan": "Nessuna pagina rimossa | {count} pagina rimossa | {count} pagine rimosse",
          "commit": "{pages} pagine in {topics} temi"
        },
        "counts": {
          "keywords": "Ricerche",
          "ordered": "Ricerche richieste",
          "received": "Risultati ricevuti",
          "missing": "Risultati mancanti",
          "clusters": "Gruppi",
          "pages": "Pagine",
          "topics": "Temi",
          "dropped": "Argomenti esclusi",
          "objectives": "Argomenti",
          "planned": "Pagine pianificate",
          "existing": "Pagine del tuo sito",
          "excluded": "Pagine escluse",
          "byRanking": "Abbinate dal posizionamento",
          "byModel": "Abbinate dalla lettura",
          "update": "Pagine da aggiornare"
        },
        "finished": "Finito {time}",
        "durationSeconds": "{count} s",
        "durationMinutes": "{count} min",
        "back": "Torna alla pianificazione",
        "rerun": "Rifai da qui",
        "rerunBlocked": "Aspetta che la pianificazione si fermi a una revisione, poi rifai.",
        "rerunConfirm": {
          "title": "Rifare da {step}?",
          "body": "I passaggi prima tengono i loro risultati. Raldo rifà il resto e si ferma alle tue revisioni.",
          "confirm": "Rifai"
        },
        "coverage": "Ambiti",
        "coverageMeta": "Cosa ha cercato Raldo",
        "terms": "Termini",
        "kept": "Tenuto",
        "dropped": "Scartato",
        "removedByYou": "Rimosso da te",
        "editsNote": "Le tue modifiche sono salvate accanto al risultato di Raldo. Raldo può mostrare entrambi.",
        "score": "{score} su 5",
        "notScored": "Non ancora valutato",
        "columns": {
          "term": "Termine",
          "coverage": "Ambito",
          "search": "Ricerca",
          "volume": "Ricerche al mese",
          "score": "Pertinenza",
          "kept": "Tenuto",
          "reason": "Perché",
          "actions": "Azioni"
        },
        "research": {
          "figures": {
            "coverage": "Ambiti",
            "terms": "Termini trovati",
            "kept": "Tenuti per pertinenza",
            "changed": "Modificati da te"
          },
          "termCount": "{count} termine | {count} termini",
          "addTerm": "Aggiungi un termine",
          "termPlaceholder": "Scrivi il termine",
          "notPlaced": "Non ancora in un ambito"
        },
        "competitors": {
          "caption": "{searches} ricerca · {website} | {searches} ricerche · {website}"
        },
        "demand": {
          "figures": {
            "measured": "Ricerche misurate",
            "units": "Ricerche trovate"
          },
          "measuredOf": "{measured} su {terms} misurate"
        },
        "relevance": {
          "figures": {
            "kept": "Ricerche tenute",
            "dropped": "Ricerche scartate"
          }
        }
      },
      "review": {
        "topicsTitle": "Rivedi i temi",
        "topicsBody": "Raldo propone {count} tema. Tienilo, rinominalo o aggiungi i tuoi, poi lascia che Raldo pianifichi le pagine. | Raldo propone {count} temi. Tieni quelli che vuoi presidiare, rinomina o rimuovi gli altri, aggiungi i tuoi, poi lascia che Raldo pianifichi le pagine.",
        "topicCounts": "Approvati: {kept} · Rimossi: {removed}",
        "keepOne": "Tieni almeno un tema.",
        "addTopic": "Aggiungi un tema",
        "namePlaceholder": "Dai un nome al tema",
        "add": "Aggiungi",
        "rename": "Rinomina",
        "remove": "Rimuovi",
        "keep": "Tieni",
        "removed": "Rimosso",
        "renamed": "Rinominato",
        "moveUp": "Sposta su",
        "moveDown": "Sposta giù",
        "addedByYou": "Aggiunto da te",
        "addedCaption": "Raldo approfondisce questo tema quando pianifica le pagine.",
        "argues": "Sostiene {names}",
        "difficulty": {
          "easy": "Facile per il tuo sito",
          "medium": "Richiede un po’ di lavoro",
          "hard": "Difficile per il tuo sito"
        },
        "topicsNote": "Raldo pianifica le pagine solo per i temi approvati. Prima approfondisce i temi che hai aggiunto.",
        "planTitle": "Rivedi il piano",
        "planHint": "Apri un tema, rimuovi le pagine che non vuoi, poi accetta il piano.",
        "hub": "Hub: {question}",
        "decisionPage": "Pagina di decisione"
      }
    },
    "research": {
      "title": "Ricerca",
      "emptyTitle": "Nessuna ricerca ancora",
      "emptyBody": "Scrivi una pagina di questo tema e Raldo risale alla fonte originale di ogni fatto che usa.",
      "readyAndWaiting": "{ready} pronte · {waiting} in attesa di una fonte",
      "entryCount": "{count} voce | {count} voci",
      "usedBy": "Usata da {count} pagina | Usata da {count} pagine",
      "notUsed": "Non ancora usata",
      "foundOn": "Trovata su {pages}",
      "waitingTitle": "In attesa di una fonte",
      "waitingCount": "{count} voce | {count} voci",
      "waitingNote": "Un ciclo le ha trovate ma non ha raggiunto una fonte originale. Non sono ancora pronte da usare.",
      "columns": {
        "research": "Ricerca",
        "foundOn": "Trovata su",
        "why": "Perché aspetta"
      },
      "forPage": "Per {page}",
      "statesItAs": "{source} lo dice così",
      "checked": "Verificata il {date}",
      "checkAgain": "Verifica di nuovo",
      "dueForCheck": "{count} voce verificata l’ultima volta oltre {days} giorni fa | {count} voci verificate l’ultima volta oltre {days} giorni fa",
      "checkedToast": "{count} voce verificata | {count} voci verificate",
      "changedCount": "{count} cambiata | {count} cambiate",
      "failedCount": "{count} non verificabile | {count} non verificabili",
      "failedToast": "Impossibile verificare {count} voce | Impossibile verificare {count} voci",
      "nothingDue": "Nessuna voce era da verificare",
      "retrievedFrom": "Recuperata da",
      "originalSource": "Fonte originale",
      "foundOnSource": "Trovata su: {title}",
      "relevantTo": "Rilevante per",
      "outlineItem": "Punto della scaletta “{item}”",
      "usedByTitle": "Usata da",
      "sectionCount": "{count} sezione | {count} sezioni",
      "section": "Sezione “{heading}”",
      "noMatch": "Nessun punto della scaletta corrisponde.",
      "noUse": "Nessuna sezione di pagina la cita ancora come fonte.",
      "notFoundTitle": "Questa voce di ricerca non esiste",
      "notFoundBody": "Un ciclo più recente potrebbe averla sostituita, o il link è sbagliato.",
      "trace": {
        "traced": "Ricondotta tramite il link",
        "tracedBySearch": "Ricondotta tramite la ricerca",
        "originNotReached": "Altre pagine la ripetono. L'originale non è stato raggiunto.",
        "originNotReachedNamed": "Altre pagine la ripetono e citano {source}. L'originale non è stato raggiunto.",
        "doesNotStateIt": "La fonte collegata non lo dice.",
        "noSourceGiven": "Nessuna fonte indicata, e la ricerca non ne ha trovata una.",
        "sentenceNotVerified": "La pagina fonte non lo dice parola per parola.",
        "notJudged": "Il ciclo ha raggiunto il limite prima di valutarla.",
        "originIsRival": "L'origine è una pagina che si posiziona o di un rivale."
      },
      "quoted": "“{quote}”"
    },
    "addPage": {
      "action": "Aggiungi una pagina",
      "title": "Aggiungi una pagina",
      "description": "Raldo aggiunge la pagina alla fine dell'ordine di scrittura di questo tema. Può richiedere fino a due minuti.",
      "questionLabel": "Domanda",
      "questionPlaceholder": "A quale domanda risponde la pagina?",
      "keywordLabel": "Keyword",
      "keywordHint": "Raldo misura quanto spesso la si cerca.",
      "tooLong": "Usa al massimo {max} caratteri.",
      "confirm": "Aggiungi pagina",
      "adding": "Aggiunge la pagina",
      "refusals": {
        "editorRequired": "Il tuo ruolo può leggere questo brand ma non modificarlo.",
        "pageExists": "Il piano ha già una pagina per questa domanda o keyword.",
        "notFit": "Raldo non è riuscito a inserire questa pagina nel tuo piano. Prova con un'altra domanda."
      }
    },
    "findMorePages": {
      "action": "Trova altre pagine",
      "needsPlan": "Crea prima un piano. Raldo vi aggiunge le nuove pagine."
    }
  },
  "article": {
    "document": {
      "askAboutPassage": "Chiedi a Raldo"
    },
    "preview": {
      "heading": "Come apparirà nei risultati",
      "titleLabel": "Titolo del risultato",
      "summaryLabel": "Riepilogo del risultato",
      "hint": "Fai clic su una riga per modificarla.",
      "address": "… › {slug}",
      "addressWithDomain": "{domain} › {slug}",
      "cutHint": "Google taglia la parte evidenziata.",
      "emptyTitle": "Aggiungi un titolo",
      "emptySummary": "Google scrive un riepilogo proprio quando questo campo è vuoto."
    },
    "todo": {
      "askRaldo": "Chiedi a Raldo"
    },
    "details": {
      "todo": "Da fare",
      "links": {
        "missingLive": "Assente dalla pagina online",
        "missingLiveTitle": "La pagina online non rimanda a «{title}»",
        "missingLiveBody": "Raldo ha letto {page} il {date}. La bozza rimanda a questa pagina, la copia pubblicata no. Ripubblica l'esportazione.",
        "missingLiveBodyUndated": "Raldo ha letto {page}. La bozza rimanda a questa pagina, la copia pubblicata no. Ripubblica l'esportazione.",
        "checkAgain": "Controlla di nuovo"
      },
      "basedOn": {
        "nothing": "Niente oltre il consenso."
      }
    },
    "panel": {
      "label": "Vista del pannello",
      "content": "Contenuto",
      "search": "Ricerca",
      "sections": "Sezioni"
    },
    "status": {
      "draft": "Bozza"
    },
    "header": {
      "publishedUrlPlaceholder": "https://tuodominio.it/blog/...",
      "publishedUrlError": "Inserisci un indirizzo web, come raldo.ai/blog/il-mio-articolo.",
      "attachUrlConfirm": "Salva",
      "openPublished": "Apri la pagina",
      "markPublished": "Segna come pubblicato",
      "promote": "Promuovi a un post",
      "export": "Esporta",
      "exportNotReady": "Esporta quando la pagina è scritta."
    },
    "inspector": {
      "groups": {
        "blockers": "Prima di pubblicare",
        "search": "Panoramica di ricerca"
      },
      "showMe": "Mostrami",
      "blockers": {
        "claims": "Una frase non ha prove | {count} frasi non hanno prove",
        "termForm": "Nomi scritti male",
        "termFormCaption": "{spellings} · {count} punto | {spellings} · {count} punti",
        "readability": "Difficile da leggere",
        "readabilityCaption": "Livello di lettura {score}, il limite è {limit}",
        "placeholders": "Ancora da compilare"
      },
      "claims": {
        "text": "Niente nel tuo materiale sostiene queste frasi.",
        "quote": "«{sentence}»"
      },
      "termForm": {
        "text": "Un nome deve avere la sua grafia.",
        "hit": "\"{from}\" si scrive \"{to}\"",
        "places": "{count} punto | {count} punti"
      },
      "readability": {
        "hardestFirst": "Prima i più difficili"
      },
      "placeholders": {
        "text": "Questi punti del testo sono ancora vuoti."
      },
      "metric": {
        "grade": "Livello di lettura {count}",
        "filler": "Nessun riempitivo | {count} riempitivo | {count} riempitivi",
        "gain": "Il {count}% delle parole aggiunge qualcosa di nuovo",
        "copies": "{count} frase copia | {count} frasi copiano",
        "noCopies": "Nessuna frase copia",
        "companyOk": "Tutti i fatti previsti sono detti",
        "companyMissing": "Manca un fatto previsto dell'azienda",
        "tablesOk": "Nessuna tabella senza fonte",
        "tablesMissing": "{count} riga di tabella senza fonte | {count} righe di tabella senza fonte"
      },
      "basedOn": {
        "answers": "Le tue risposte",
        "answersText": "Cosa hai detto a Raldo e dove l'autore l'ha usato.",
        "yourAnswer": "La tua risposta",
        "brand": "Il tuo brand",
        "brandText": "Fatti del tuo brand che hanno dato forma al testo.",
        "sources": "Fonti citate",
        "sourcesText": "Ogni fatto che il testo prende da un altro sito.",
        "pages": "Pagine lette dall'autore",
        "pagesText": "Le pagine in classifica che Raldo ha letto prima di scrivere. Non citate.",
        "pageSections": "{count} sezione | {count} sezioni",
        "adds": "Cosa aggiunge questa pagina",
        "addsText": "Cosa non dicono le pagine in classifica."
      },
      "gain": {
        "ai-answers": "Risposte dell'IA",
        "brand": "Il tuo brand",
        "disagreement": "Disaccordo"
      },
      "publishing": {
        "faq": "Schema FAQ",
        "faqText": "Le domande che il CMS riceve come dati strutturati.",
        "links": "Link alle tue pagine",
        "linksText": "Pagine del tema a cui questa pagina rimanda, al loro indirizzo attuale. Una pagina non ancora pubblicata andrà online più tardi.",
        "notLive": "Andrà online più tardi"
      }
    },
    "sources": {
      "title": "Fonti"
    },
    "look": {
      "title": "Da dare un'occhiata",
      "headingCase": "Titolo in Title Case",
      "headingCaseText": "I titoli si leggono meglio senza Title Case.",
      "keywordHeading": "Parola chiave non in un titolo",
      "keywordHeadingText": "Nessun titolo di sezione contiene la parola chiave principale.",
      "rule": "Regola di scrittura",
      "noNearCopy": {
        "title": "Copia una pagina in classifica",
        "caption": "{count} frase | {count} frasi",
        "text": "Queste frasi condividono una lunga sequenza di parole con una pagina in classifica.",
        "ask": "Chiedi a Raldo di riformularle",
        "askMessage": "Riformula le frasi che copiano pagine in classifica."
      },
      "noFiller": {
        "title": "Riempitivo",
        "caption": "{count} sezione | {count} sezioni",
        "text": "Frasi che servono solo a riempire spazio."
      },
      "statesGain": {
        "title": "Non dice nulla di nuovo",
        "caption": "{count} sezione | {count} sezioni",
        "text": "La sezione dice solo ciò che le pagine in classifica dicono già."
      }
    },
    "top": {
      "words": "{count} parola | {count} parole",
      "faqs": "{count} FAQ | {count} FAQ",
      "links": "{count} link | {count} link"
    }
  },
  "notes": {
    "toast": {
      "addEntryFailed": "Impossibile aggiungere questa voce",
      "saveEditFailed": "Impossibile salvare questa modifica",
      "deleteEntryFailed": "Impossibile eliminare questa voce"
    },
    "deleteEntryTitle": "Eliminare questa voce?",
    "deleteEntryBody": "Questo lo rimuove dalle tue note. Non può essere annullato da qui.",
    "removeLink": "Rimuovi link",
    "composerPlaceholder": "Cosa dovrebbe sapere Raldo?"
  },
  "insights": {
    "impressionsLabel": "Impressioni",
    "reachLabel": "Copertura"
  },
  "chat": {
    "untitledChat": "Chat senza titolo",
    "conversationLabel": "Conversazione",
    "scrollToBottom": "Scorri in fondo",
    "backToWhereIWas": "Torna al punto in cui ero",
    "removeContextItem": "Rimuovi {label}",
    "context": {
      "passage": "«{text}»"
    },
    "closedThreadMessage": "Questa chat è chiusa. Avvia una nuova chat per continuare.",
    "deleteDialog": {
      "title": "Eliminare \"{name}\"?",
      "description": "Questa conversazione e tutti i suoi messaggi vengono eliminati definitivamente. Non può essere annullato."
    },
    "errors": {
      "rateLimited": "Hai raggiunto il limite di messaggi. Attendi un momento e riprova.",
      "notYours": "Questa conversazione appartiene a qualcun altro.",
      "deleteFailed": "Impossibile eliminare questa conversazione",
      "loadThreadsFailed": "Impossibile caricare le tue conversazioni",
      "loadThreadFailed": "Impossibile caricare questa conversazione"
    },
    "dock": {
      "close": "Chiudi chat",
      "label": "Chat contestuale",
      "askRaldo": "Chiedi a Raldo",
      "resize": "Ridimensiona il pannello"
    },
    "composer": {
      "placeholder": "Scrivi qualcosa",
      "send": "Invia",
      "stop": "Interrompi",
      "attach": "Allega un'immagine",
      "attachedImage": "Immagine allegata",
      "removeImage": "Rimuovi immagine",
      "uploadingImage": "Caricamento immagine",
      "retry": "Riprova",
      "tabKey": "Tab",
      "dropToAttach": "Rilascia per allegare",
      "keyHint": "Invio invia · Maiusc e Invio vanno a capo"
    },
    "agentPulse": "Raldo sta lavorando",
    "badge": {
      "closed": "Chiusa"
    },
    "nav": {
      "chats": "Chat",
      "newChat": "Nuova chat",
      "seeAll": "Vedi tutte le chat"
    },
    "archive": {
      "messageCount": "1 messaggio | {count} messaggi",
      "actionsFor": "Azioni per {title}"
    },
    "chatsView": {
      "loading": "Caricamento delle conversazioni in corso",
      "tryAgain": "Riprova",
      "emptyTitle": "Nessuna conversazione ancora",
      "emptyDescription": "Ogni chat che avvii con Raldo viene conservata qui, dalla più recente.",
      "listAria": "Conversazioni",
      "showingRange": "Visualizzazione da {start} a {end}",
      "previous": "Precedente",
      "next": "Successivo"
    },
    "activity": {
      "thinking": "Sta pensando…",
      "webSearch": "Ricerca sul web in corso…",
      "research": "Ricerca sul competitor in corso…",
      "drafting": "Bozza del briefing in corso…",
      "editing": "Modifica del testo in corso…",
      "generating": "Generazione in corso…",
      "navigating": "Apertura in corso…",
      "failed": "non riuscito",
      "notOpened": "Non aperto",
      "inProgress": "in corso",
      "done": "completato",
      "pending": "in attesa",
      "opener": "Sta pensando",
      "workedSummary": "Ha lavorato per {seconds}s · {count} passaggio | Ha lavorato per {seconds}s · {count} passaggi",
      "workedSummaryUnknownDuration": "Ha completato {count} passaggio | Ha completato {count} passaggi",
      "summaryWithFailures": "{summary} · {failed}",
      "failedCount": "{count} non riuscito | {count} non riusciti",
      "moreSources": "+{count} altro | +{count} altri",
      "searchingWebFor": "Sta cercando sul web «{query}»",
      "searchGroup": "Sta cercando sul web · {count} ricerca | Sta cercando sul web · {count} ricerche",
      "resultCount": "{count} risultato | {count} risultati",
      "searching": "Ricerca in corso…",
      "label": {
        "fallback": {
          "thinking": "Sta pensando",
          "webSearch": "Sta cercando sul web",
          "research": "Sta cercando informazioni",
          "drafting": "Sta scrivendo una bozza",
          "editing": "Sta apportando una modifica",
          "generating": "Sta generando",
          "navigating": "Sta aprendo una schermata"
        },
        "question": {
          "asking": "Sta facendo una domanda"
        },
        "documents": {
          "listing": "Sta controllando i documenti disponibili",
          "reading": "Sta leggendo un documento"
        },
        "knowledge": {
          "listing": "Sta controllando le tue conoscenze",
          "readingPage": "Sta leggendo una pagina di conoscenza",
          "organizing": "Sta organizzando le tue conoscenze"
        },
        "inbox": {
          "checking": "Controlla la posta in arrivo"
        },
        "memoryCandidate": {
          "noting": "Sta annotando qualcosa da ricordare"
        },
        "memory": {
          "checking": "Sta controllando la memoria del brand",
          "readingPage": "Sta leggendo una pagina di memoria",
          "followingLink": "Sta seguendo un collegamento di memoria"
        },
        "socialConnect": {
          "offeringLinkedIn": "Propone di collegare LinkedIn",
          "checkingLinkedIn": "Sta controllando la connessione LinkedIn"
        },
        "research": {
          "checkingAnalytics": "Sta controllando le analitiche",
          "checkingTrackedCompetitors": "Sta controllando i competitor monitorati",
          "checkingCompetitorReport": "Sta controllando il report sui competitor",
          "checkingRecentContent": "Sta controllando i contenuti recenti",
          "readingPost": "Sta leggendo il post",
          "searchingWeb": "Sta cercando sul web",
          "readingWebPage": "Sta leggendo una pagina web",
          "checkingSimilarCompanies": "Sta controllando aziende simili",
          "readingLinkedInPage": "Sta leggendo la pagina LinkedIn",
          "checkingPostHistory": "Sta controllando la cronologia del post",
          "checkingDesigns": "Sta controllando i tuoi design",
          "readingPrompts": "Sta leggendo i tuoi prompt per le risposte IA",
          "readingPlan": "Sta leggendo il piano",
          "readingResearch": "Sta leggendo la ricerca di un tema"
        },
        "competitor": {
          "adding": "Sta aggiungendo un competitor"
        },
        "competitors": {
          "analyzing": "Sta analizzando i competitor"
        },
        "design": {
          "starting": "Avvio di un design",
          "checkingRun": "Controllo dell’esecuzione del design",
          "attachingToPost": "Aggiunta del design al post",
          "addingReference": "Aggiunta di un’immagine di riferimento",
          "checkingReferences": "Controllo delle immagini di riferimento",
          "editing": "Modifica del design",
          "checkingEdit": "Controllo della modifica al design"
        },
        "styleGuide": {
          "readingPosts": "Sta leggendo i post del brand"
        },
        "visualStyle": {
          "checking": "Sta controllando lo stile visivo",
          "writing": "Sta scrivendo lo stile visivo"
        },
        "onboarding": {
          "completing": "Sta completando l'onboarding"
        },
        "post": {
          "editing": "Sta modificando il post",
          "publishingNow": "Sta pubblicando il post ora",
          "scheduling": "Sta programmando il post",
          "writing": "Scrive un post"
        },
        "note": {
          "logging": "Sta registrando una nota"
        },
        "companyProfile": {
          "readingWebsite": "Sta leggendo il sito web dell'azienda"
        },
        "brandFoundation": {
          "drafting": "Sta scrivendo le basi del brand"
        },
        "knowledgePage": {
          "writing": "Sta scrivendo una pagina di conoscenza"
        },
        "document": {
          "writingNamed": "Sta scrivendo il tuo {name}",
          "writingGeneric": "Sta scrivendo in un documento",
          "approvingNamed": "Sta approvando il tuo {name}",
          "approvingGeneric": "Sta approvando un documento"
        },
        "stage": {
          "openingScreen": "Sta aprendo {screen}",
          "openingGeneric": "Sta aprendo una schermata"
        },
        "workspace": {
          "listingFiles": "Elenco dei file dell’area di lavoro",
          "readingFile": "Lettura di un file dell’area di lavoro",
          "writingFile": "Scrittura di un file dell’area di lavoro",
          "editingFile": "Modifica di un file dell’area di lavoro",
          "deletingFile": "Eliminazione di un file dell’area di lavoro",
          "renderingPage": "Rendering di una pagina",
          "listingReferences": "Elenco delle immagini di riferimento",
          "readingReference": "Lettura di un’immagine di riferimento",
          "importingImage": "Sta importando un'immagine"
        },
        "page": {
          "writing": "Sta scrivendo la pagina",
          "adding": "Aggiunge una pagina"
        },
        "topic": {
          "adding": "Aggiunge un argomento"
        }
      },
      "outcome": {
        "documentUpdated": "{name} aggiornato",
        "documentApproved": "{name} approvato",
        "styleGuideBuilt": "Creata da {sampleCount} post",
        "visualStyleSaved": "Stile visivo salvato",
        "companyProfileSaved": "Profilo aziendale salvato",
        "competitorAdded": "{name} aggiunto",
        "competitorsAnalyzed": "{count} competitor analizzati",
        "designRunStarted": "Design avviato: {designName}",
        "designAttachedToPost": "Design aggiunto al post",
        "designReferenceAdded": "{name} aggiunto",
        "postScheduled": "Post programmato",
        "postPublished": "Post pubblicato",
        "postEdited": "Post aggiornato",
        "noteLogged": "Nota registrata",
        "knowledgePageWritten": "{title} salvato",
        "knowledgeOrganized": "Conoscenze organizzate",
        "artifactLinked": "Visualizza {name}",
        "pageWriteStarted": "Pagina avviata: {title}",
        "postWriteStarted": "Post avviato",
        "pageAdded": "Pagina aggiunta: {title}",
        "designEditStarted": "Modifica del design avviata",
        "topicAdded": "Argomento aggiunto: {title}"
      }
    },
    "agentAsk": {
      "action": {
        "allow": "Consenti",
        "notNow": "Non ora",
        "done": "Fatto.",
        "declined": "Hai detto di no.",
        "expired": "La richiesta è scaduta. Chiedi di nuovo a Raldo se la vuoi ancora.",
        "cannotUndo": "Questa azione non può essere annullata.",
        "failedNote": "Hai autorizzato l'azione, ma non è andata a buon fine: {reason}",
        "settled": "Questa richiesta è stata definita."
      },
      "question": {
        "typeAnswer": "Scrivi una risposta",
        "answered": "Risposto.",
        "expired": "La richiesta è scaduta. Chiedi di nuovo a Raldo se la vuoi ancora.",
        "settled": "Questa domanda è stata definita."
      },
      "connect": {
        "caption": "Pubblica e programma i post direttamente da Raldo.",
        "connect": "Connetti {platform}",
        "skip": "Per ora no",
        "connected": "{platform} connesso.",
        "expired": "La richiesta è scaduta. Chiedi di nuovo a Raldo se vuoi ancora connetterti.",
        "settled": "Questa richiesta di connessione è stata definita."
      }
    },
    "sources": {
      "count": "1 fonte | {count} fonti",
      "yourKnowledge": "La tua conoscenza"
    },
    "designSuggestions": {
      "label": "Modifiche suggerite",
      "bigger": "Ingrandiscilo",
      "dropRow": "Togli una riga",
      "accent": "Usa il colore d'accento",
      "moveUp": "Spostalo un po' più su",
      "fit": "Fallo entrare"
    }
  },
  "home": {
    "yourBrandFallback": "il tuo brand",
    "conversationStarted": "Conversazione avviata.",
    "composerPlaceholders": [
      "Fai una ricerca su un competitor",
      "Scrivi la bozza di un post per LinkedIn",
      "Rivedi la performance di {name} nell'ultimo mese",
      "Pianifica i contenuti per la settimana prossima"
    ],
    "demo": {
      "searchedCompetitorPricing": "Ha cercato in 6 pagine dei prezzi dei competitor i piani a consumo.",
      "comparedCompetitorFraming": "Ha confrontato come il Competitor X presenta i costi extra rispetto alle fasce di utilizzo prestabilite.",
      "answerMarkdown": "Ecco come lo posizionerei: parti da **crescita prevedibile, non sovrapprezzi punitivi** -\nIl Competitor X continua a presentare i prezzi a consumo con fasce penalizzanti, il che comunica\npaura più che valore.\n\n- Ancora il titolo al valore del controllo dei costi, non al consumo\n- Mostra un confronto affiancato tra \"paghi quello che si rompe\" e \"paghi quello che cresce\"\n- Chiudi con una citazione di un cliente sui ricavi da espansione, non sulla paura del rinnovo\n\nVuoi che lo trasformi in un one-pager completo per il team vendite?"
    }
  },
  "setup": {
    "stepList": "Avanzamento della configurazione",
    "stepOf": "Passo {number} di {total}",
    "stepDone": "Fatto",
    "founderLetter": {
      "title": "Il viaggio comincia",
      "greeting": "Ciao {name},",
      "greetingAnonymous": "Ciao,",
      "intro": "sono {name}, il fondatore di Raldo. {thanks}",
      "thanks": "Sono felice che tu sia qui. Grazie.",
      "story": "Ho creato Raldo per risolvere un mio problema: pubblicare ogni settimana contenuti rilevanti che portano nuovi clienti, senza esaurirmi. Oggi Raldo scrive tutti i nostri contenuti. Se ci hai trovato, ha funzionato almeno una volta.",
      "plan": "Ora tocca a te. Prima che Raldo possa fare qualcosa per te, deve capire la tua azienda e il settore in cui lavori. Questo significa fatti sul tuo marchio, sui tuoi concorrenti e sui tuoi clienti. {time} Raldo farà il grosso del lavoro. Il tuo compito è giudicare: digli cosa non va e cosa potrebbe essere migliore. {care} Tutto ciò che Raldo creerà per te si baserà su queste fondamenta.",
      "time": "Calcola circa 15 minuti.",
      "care": "Non avere fretta in questa parte.",
      "closing": "Grazie ancora, e cominciamo.",
      "ps": "{label} Se qualcosa non ti sembra giusto, o vuoi solo salutarmi, scrivimi a {email}. Raldo è un'IA, la mia casella di posta no. Leggo e rispondo personalmente a ogni email.",
      "psLabel": "P.S.",
      "start": "Inizia la configurazione"
    },
    "steps": {
      "brandFacts": {
        "title": "Fatti del marchio",
        "heading": "Fatti sul tuo marchio",
        "description": "Che cosa fa la tua azienda e per chi"
      },
      "competitors": {
        "title": "Concorrenti",
        "description": "Le aziende con cui i tuoi clienti ti confrontano"
      },
      "customerProfile": {
        "title": "Profilo cliente",
        "description": "Chi sono i tuoi clienti"
      },
      "strategy": {
        "title": "Strategia dei contenuti",
        "description": "Il piano dietro i tuoi contenuti"
      },
      "visualStyle": {
        "title": "Stile visivo",
        "description": "Come appaiono i tuoi post"
      }
    },
    "common": {
      "retry": "Riprova",
      "edit": "Modifica",
      "edited": "Modificato",
      "sources": {
        "pages": "{count} pagina | {count} pagine",
        "readFrom": "Raldo lo ha letto da"
      },
      "runErrors": {
        "generic": "Qualcosa è andato storto. Riprova.",
        "timedOut": "La lettura ha richiesto troppo tempo. Riprova."
      },
      "saved": "Salvato"
    },
    "errors": {
      "startFailed": "Non siamo riusciti ad avviare la lettura",
      "confirmFailed": "Non siamo riusciti a salvare questo passo"
    },
    "locked": {
      "change": "Cambia",
      "laterStepRunning": "Raldo sta ancora lavorando a un passo successivo. Riprova quando ha finito.",
      "brandFacts": {
        "title": "Hai confermato i fatti del tuo marchio",
        "body": "Raldo li ha usati per trovare i tuoi concorrenti, per il tuo profilo cliente e per la tua strategia dei contenuti.",
        "alertTitle": "Cambiare i fatti del marchio?",
        "alertBody": "Raldo cercherà di nuovo i tuoi concorrenti con i fatti che confermi. Poi rifà il tuo profilo cliente e la tua strategia dei contenuti. Le nuove versioni sostituiscono quelle salvate e le tue modifiche in quei passi vanno perse. Poi confermi di nuovo il tuo stile visivo.",
        "alertConfirm": "Cambia i fatti del marchio"
      },
      "competitors": {
        "title": "Hai confermato questi concorrenti",
        "body": "Raldo li ha usati per il tuo profilo cliente e la tua strategia dei contenuti.",
        "alertTitle": "Cambiare i concorrenti?",
        "alertBody": "Raldo leggerà le aziende che scegli. Poi rifà il tuo profilo cliente e la tua strategia dei contenuti. Le nuove versioni sostituiscono quelle salvate e le tue modifiche in quei passi vanno perse. Poi confermi di nuovo il tuo stile visivo.",
        "alertConfirm": "Cambia i concorrenti"
      },
      "customerProfile": {
        "title": "Hai confermato il tuo profilo cliente",
        "body": "Raldo lo ha usato per la tua strategia dei contenuti.",
        "alertTitle": "Cambiare il profilo cliente?",
        "alertBody": "Raldo rifarà la tua strategia dei contenuti dal profilo che confermi. La nuova versione sostituisce quella salvata e le tue modifiche lì vanno perse. Poi confermi di nuovo il tuo stile visivo.",
        "alertConfirm": "Cambia il profilo cliente"
      },
      "strategy": {
        "title": "Hai confermato la tua strategia dei contenuti",
        "body": "Raldo la usa in tutto ciò che scrive per te.",
        "alertTitle": "Vuoi cambiare la tua strategia dei contenuti?",
        "alertBody": "Dopo aver confermato la nuova strategia, confermi di nuovo il tuo stile visivo.",
        "alertConfirm": "Cambia strategia dei contenuti"
      },
      "visualStyle": {
        "title": "Hai confermato il tuo stile visivo",
        "body": "Raldo lo usa per l'aspetto dei tuoi post."
      }
    },
    "loadFailed": {
      "title": "Non siamo riusciti a caricare la configurazione",
      "line": "Controlla la connessione e riprova."
    },
    "ring": {
      "progress": "{done} di {total} pagine lette"
    },
    "brandFacts": {
      "links": {
        "subtitle": "Partiamo dalle basi.",
        "website": {
          "label": "Sito web",
          "hint": "Inserisci la pagina principale dell'azienda per i clienti.",
          "placeholder": "https://tuaazienda.it"
        },
        "linkedIn": {
          "label": "Pagina aziendale LinkedIn",
          "hint": "Il link in alto nella pagina LinkedIn della tua azienda, quando scegli \"Visualizza come membro\". Funzionano solo le pagine aziendali.",
          "placeholder": "https://linkedin.com/company/tuaazienda"
        },
        "submit": "Leggi le mie pagine",
        "next": "Avanti",
        "websiteError": "Inserisci un indirizzo web, come tuaazienda.it.",
        "linkedInAddressError": "Inserisci un indirizzo web, come linkedin.com/company/tuaazienda.",
        "linkedInError": "Questo è un profilo personale. Inserisci la tua pagina aziendale. Inizia con linkedin.com/company/.",
        "editTitle": "Modifica i tuoi link",
        "editHint": "Raldo rilegge le tue pagine e aggiorna la scheda."
      },
      "reading": {
        "title": "Lettura delle tue pagine",
        "ghost": "Lettura",
        "stages": {
          "website": "Lettura del tuo sito",
          "look": "Lettura del logo e di come scrivi",
          "extract": "Scrittura dei fatti"
        },
        "failedTitle": "Non siamo riusciti a leggere le tue pagine",
        "errors": {
          "websiteReadFailed": "Non siamo riusciti a leggere il tuo sito. Controlla il link e riprova.",
          "noPages": "Non abbiamo trovato pagine. Controlla il link del sito.",
          "extractionFailed": "Non siamo riusciti a scrivere i fatti. Riprova.",
          "enqueueFailed": "Non siamo riusciti ad avviare. Riprova.",
          "readFailed": "Controlla i due link e riprova."
        }
      },
      "sheet": {
        "readAgain": "Leggi di nuovo",
        "confirm": "Conferma",
        "ghost": {
          "region": "Aggiungi un paese o una regione",
          "people": "Aggiungi una persona",
          "text": "Non è sulle tue pagine.",
          "textAction": "Scrivilo in una frase"
        },
        "regionCountries": "{count} paese | {count} paesi",
        "moreCountries": "e altri {count}"
      },
      "summary": {
        "colours": "Colori del brand",
        "dialogTitle": "Modifica il riepilogo",
        "lookTitle": "Logo, colori e carattere",
        "changeLater": "Puoi cambiarli più tardi in {section}, {page}.",
        "voiceTitle": "Come scrivi",
        "openPage": "Apri {page}",
        "voiceMissing": "Raldo non è riuscito a leggerlo dal tuo sito. Chiedi a Raldo in {section}, {page} di riprovare."
      },
      "dialog": {
        "addPerson": "Aggiungi una persona",
        "remove": "Rimuovi",
        "name": "Nome",
        "role": "Ruolo",
        "regionLabel": "Regione",
        "regionHint": "Scrivi un paese o una regione. Una regione vale come ogni paese al suo interno.",
        "regionPlaceholder": "Scrivi un paese o una regione",
        "regionEmpty": "Nessun paese o regione corrisponde.",
        "regions": "Regioni",
        "countries": "Paesi",
        "inRegion": "in {region}",
        "nameRequired": "Inserisci un nome."
      },
      "runInProgress": "Raldo sta già leggendo le tue pagine. Attendi la fine.",
      "rows": {
        "brandInCategory": {
          "name": "Marchio nella categoria",
          "hint": "Cosa sei, in una frase. Raldo la ripete parola per parola.",
          "editTitle": "Modifica marchio nella categoria"
        },
        "category": {
          "name": "Categoria",
          "hint": "Le parole che un cliente usa per cercare",
          "editTitle": "Modifica categoria"
        },
        "problemItSolves": {
          "name": "Problema risolto",
          "hint": "Il problema che il tuo sito dice di risolvere",
          "editTitle": "Modifica problema risolto"
        },
        "targetCustomer": {
          "name": "Cliente tipo",
          "hint": "I tipi di cliente citati sul tuo sito",
          "editTitle": "Modifica cliente tipo"
        },
        "categoryDefinition": {
          "name": "Definizione della categoria",
          "hint": "La frase che definisce la tua categoria",
          "editTitle": "Modifica definizione della categoria"
        },
        "approach": {
          "name": "Approccio",
          "hint": "Come lo fai, e l'idea dietro questo modo",
          "editTitle": "Modifica approccio"
        },
        "region": {
          "name": "Regione",
          "hint": "I paesi che servi",
          "editTitle": "Modifica regione"
        },
        "people": {
          "name": "Persone",
          "hint": "Fondatori e membri del team citati sulle tue pagine",
          "editTitle": "Modifica persone"
        }
      },
      "noRole": "Nessun ruolo per ora"
    },
    "competitors": {
      "known": {
        "subtitle": "Contro chi ti confronti?",
        "lead": "Ora Raldo cerca i tuoi concorrenti. Ti vengono in mente uno o due nomi? Oppure lascia cercare Raldo.",
        "namedTitle": "Ne conosco alcuni",
        "namedCaption": "Aggiungine uno o due. Raldo ne cerca altri simili.",
        "searchTitle": "Lascia cercare Raldo",
        "searchCaption": "Raldo parte dai fatti del tuo brand. Non devi preparare nulla."
      },
      "name": {
        "addLabel": "Chi ti viene in mente?",
        "addHint": "Uno o due bastano.",
        "start": "Trova altri simili"
      },
      "finding": {
        "errors": {
          "enqueueFailed": "Non siamo riusciti ad avviare la ricerca. Riprova.",
          "discoveryFailed": "Non abbiamo trovato aziende simili alla tua. Riprova.",
          "timedOut": "La ricerca ha richiesto troppo tempo. Riprova.",
          "startFailed": "Non siamo riusciti ad avviare la ricerca. Riprova."
        },
        "title": "Cerchiamo i tuoi concorrenti",
        "failedTitle": "Non abbiamo trovato i tuoi concorrenti",
        "stages": {
          "snapshot": "Leggiamo per cosa ti posizioni già",
          "similar": "Guardiamo aziende simili alla tua",
          "search": "Cerchiamo nel tuo settore",
          "rank": "Ordiniamo i risultati"
        },
        "lists": {
          "similar": "Aziende simili",
          "samePages": "Siti come il tuo",
          "comparisonPages": "Pagine di confronto",
          "searchRivals": "Rivali nella ricerca",
          "namedRivals": "Rivali delle aziende che hai indicato"
        },
        "found": "Nessuna azienda trovata finora | {count} azienda trovata | {count} aziende trovate"
      },
      "review": {
        "title": "I tuoi concorrenti",
        "lead": "Abbiamo trovato {count} aziende e le abbiamo ordinate per quanto sono vicine a te. Abbiamo spuntato le {max} più vicine. Scegline fino a {max}.",
        "leadNamed": "Abbiamo trovato {count} aziende e le abbiamo ordinate per quanto sono vicine a te. Abbiamo spuntato le {named} che hai indicato. Scegline fino a {max}.",
        "groups": {
          "direct": {
            "title": "Concorrenti più vicini",
            "description": "Vendono la stessa cosa agli stessi clienti."
          },
          "alternative": {
            "title": "Altre opzioni",
            "description": "I tuoi clienti possono usarle per fare lo stesso lavoro in un altro modo."
          },
          "notRelevant": {
            "title": "Trovate anche",
            "description": "Pensiamo che queste non siano concorrenti. Apri la lista se sbagliamo."
          }
        },
        "pickName": "Scegli {name}",
        "picked": "{count} di {max} scelte",
        "picks": {
          "title": "Le tue scelte",
          "empty": "Spunta le aziende qui sopra o aggiungine una qui sotto.",
          "full": "Hai scelto {max} aziende su {max}. Togline una qui sopra per aggiungerne un'altra.",
          "remove": "Rimuovi {name}"
        },
        "added": "{name} aggiunta e scelta.",
        "ticked": "{name} era già in «{group}». Ora è scelta.",
        "addLabel": "Manca un'azienda? Aggiungila",
        "addHint": "Un'azienda che aggiungi viene spuntata per te.",
        "empty": "Nessuna azienda trovata. Aggiungine almeno una qui sotto.",
        "confirm": "Conferma",
        "sharesKeywords": "Compare per {count} delle tue parole chiave"
      }
    },
    "customerProfile": {
      "reading": {
        "title": "Scriviamo il profilo del tuo cliente",
        "failedTitle": "Non siamo riusciti a scrivere il profilo del tuo cliente",
        "detail": "Dai fatti del tuo brand e dai concorrenti",
        "ghost": "In scrittura",
        "errors": {
          "enqueueFailed": "Non siamo riusciti ad avviare il profilo. Riprova.",
          "draftFailed": "Non siamo riusciti a scrivere il profilo del tuo cliente. Riprova.",
          "factsMissing": "Prima servono i fatti del tuo brand e i concorrenti. Controllali, poi riprova.",
          "timedOut": "Il profilo ha richiesto troppo tempo. Riprova.",
          "startFailed": "Non siamo riusciti ad avviare il profilo. Riprova."
        }
      },
      "profile": {
        "title": "Il tuo cliente",
        "subtitle": "L'unica persona che sente il problema e fa la scelta d'acquisto",
        "writeAgain": "Riscrivi",
        "confirm": "Conferma",
        "editSummary": "Modifica il riepilogo",
        "untitled": "Il tuo cliente"
      },
      "job": {
        "title": "Il lavoro per cui cercano aiuto",
        "progress": "Cosa vogliono",
        "goal": "Il loro obiettivo",
        "stories": "Quando conta",
        "when": "Quando",
        "want": "vogliono",
        "soThat": "così che",
        "editStory": "Modifica questa storia"
      },
      "cards": {
        "tried": {
          "title": "Cosa usano oggi",
          "hint": "Cosa hanno usato prima i clienti",
          "editTitle": "Modifica cosa hanno provato"
        },
        "blockers": {
          "title": "Cosa li frena",
          "hint": "Cosa preoccupa i clienti o li fa aspettare",
          "editTitle": "Modifica cosa temono"
        }
      },
      "card": {
        "lines": "Righe",
        "addLine": "Aggiungi una riga",
        "add": "Aggiungi",
        "removeLine": "Rimuovi {label}",
        "lineTooLong": "Una riga è troppo lunga. Rimuovila e aggiungine una più corta."
      },
      "summaryDialog": {
        "title": "Modifica il riepilogo",
        "hint": "Il titolo, la dimensione aziendale e il riepilogo",
        "titleLabel": "Titolo",
        "companySizeLabel": "Dimensione aziendale",
        "summaryLabel": "Riepilogo",
        "writeAgain": "Riscrivi"
      },
      "companySize": {
        "solo": "Solo io",
        "upTo10": "Da 2 a 10 persone",
        "upTo50": "Da 11 a 50 persone",
        "upTo200": "Da 51 a 200 persone",
        "upTo1000": "Da 201 a 1.000 persone",
        "over1000": "Oltre 1.000 persone"
      },
      "errors": {
        "writeSummaryFailed": "Non siamo riusciti a scrivere un nuovo riepilogo"
      },
      "limits": {
        "tooLong": "Usa al massimo {max} caratteri."
      },
      "refusals": {
        "labelTooLong": "Una riga è troppo lunga. Accorciala.",
        "labelRequired": "Una riga è vuota. Scrivi qualcosa o rimuovi la riga.",
        "triedTooMany": "Cosa usano oggi ha al massimo 4 righe. Rimuovine prima una.",
        "titleTooLong": "Il titolo è troppo lungo. Accorcialo.",
        "summaryTooLong": "Il riepilogo è troppo lungo. Accorcialo.",
        "rowsEmpty": "Tutte le schede sono vuote. Aggiungi prima una riga a una scheda.",
        "runInProgress": "Raldo sta ancora scrivendo il profilo del tuo cliente. Aspetta che finisca.",
        "factsMissing": "Conferma prima i dati del tuo brand.",
        "competitorsMissing": "Aggiungi prima i tuoi concorrenti.",
        "ownerAdminRequired": "Solo un titolare o un admin può farlo.",
        "editorRequired": "Il tuo ruolo può leggere questo brand ma non modificarlo."
      }
    },
    "contentStrategy": {
      "reading": {
        "title": "Raldo scrive la tua strategia dei contenuti",
        "failedTitle": "Raldo non è riuscito a scrivere la tua strategia dei contenuti",
        "questions": "{done} domande su {total}",
        "writing": "Raldo scrive",
        "stages": {
          "awareness": "Raldo scrive cosa devono credere sul problema",
          "consideration": "Raldo scrive cosa devono credere sulle loro opzioni",
          "decision": "Raldo scrive cosa devono credere su di te",
          "core": "Raldo scrive il tuo messaggio chiave"
        },
        "chips": {
          "awareness": "Il problema",
          "consideration": "Le opzioni",
          "decision": "Perché tu",
          "core": "Messaggio chiave"
        },
        "errors": {
          "enqueueFailed": "Raldo non è riuscito a iniziare a scrivere. Riprova.",
          "draftFailed": "Raldo non è riuscito a scrivere la tua strategia dei contenuti. Riprova.",
          "profileMissing": "Conferma prima il profilo del tuo cliente. Poi riprova.",
          "factsMissing": "Conferma prima i dati del tuo brand. Poi riprova.",
          "timedOut": "La scrittura ha richiesto troppo tempo. Riprova.",
          "startFailed": "Raldo non è riuscito a iniziare a scrivere. Riprova."
        }
      },
      "refusals": {
        "runInProgress": "Raldo sta ancora scrivendo la tua strategia dei contenuti. Aspetta che finisca.",
        "profileMissing": "Conferma prima il profilo del tuo cliente.",
        "beliefMapMissing": "Raldo non ha ancora scritto i tuoi obiettivi.",
        "coreMessageMissing": "Scrivi prima il tuo messaggio chiave.",
        "strategyMissing": "Raldo non ha ancora scritto la tua strategia dei contenuti.",
        "replacesTooLong": "Cosa pensano oggi può avere al massimo 500 caratteri.",
        "ownerAdminRequired": "Solo un titolare o un admin può farlo.",
        "editorRequired": "Il tuo ruolo può leggere questo brand ma non modificarlo."
      },
      "writeAgain": {
        "title": "Scrivere di nuovo?",
        "body": "Raldo scrive di nuovo la tua strategia dei contenuti. Il nuovo testo sostituisce il testo che non hai modificato.",
        "confirm": "Scrivi di nuovo"
      },
      "page": {
        "title": "La tua strategia dei contenuti",
        "writeAgain": "Scrivi di nuovo",
        "confirm": "Conferma",
        "info": {
          "title": "La tua strategia dei contenuti fissa l’obiettivo di ogni contenuto che Raldo scrive.",
          "body": "Prima di sceglierti, i clienti devono arrivare a credere alcune cose: che il loro problema è reale, che le soluzioni solite non bastano e che scegliere te è sicuro. Raldo trasforma ognuna in un argomento e dà a ogni contenuto un argomento da sostenere. Ogni contenuto parla a un lettore: il tuo cliente ideale, in una fase del suo percorso, da quando nota il problema a quando decide."
        }
      },
      "coreMessage": {
        "title": "Il messaggio chiave dietro i tuoi contenuti",
        "caption": "Cosa devono credere i potenziali clienti per comprare da te",
        "edit": "Modifica il tuo messaggio chiave",
        "empty": "Raldo non è ancora riuscito a scrivere il tuo messaggio chiave.",
        "write": "Scrivilo",
        "yours": "Il tuo messaggio chiave"
      },
      "stages": {
        "awareness": {
          "objective": "Aiutali a capire il problema",
          "note": "I tuoi contenuti spiegano il problema con le loro parole e perché conta, senza vendere."
        },
        "consideration": {
          "objective": "Aiutali a valutare le opzioni",
          "note": "I tuoi contenuti li aiutano a confrontare le opzioni e a vedere dove si colloca il tuo approccio."
        },
        "decision": {
          "objective": "Aiutali a scegliere con fiducia",
          "note": "I tuoi contenuti spiegano come lavori, cosa ottengono e cosa succede dopo l’acquisto."
        }
      },
      "stage": {
        "heading": "{phase} · {objective}",
        "asks": "Si chiedono: {question} {note}",
        "compareWith": "Ti confrontano con"
      },
      "formats": {
        "howTo": "Guida pratica",
        "research": "Ricerche e dati",
        "pointOfView": "Punto di vista",
        "comparison": "Confronto",
        "customerStory": "Storia di un cliente",
        "productExplainer": "Spiegazione del prodotto",
        "objection": "Risposta a un’obiezione",
        "pricing": "Prezzi spiegati",
        "ourStory": "La nostra storia"
      },
      "subjects": {
        "problem": "Il problema",
        "prevalence": "Quanto è diffuso",
        "cost": "Perché conta",
        "options": "Le altre opzioni",
        "ourOption": "Il tuo modo",
        "fit": "Fa per loro",
        "brand": "La tua azienda",
        "offer": "La tua offerta",
        "afterPurchase": "Dopo l’acquisto"
      },
      "ledger": {
        "thinks": "Cosa pensano oggi",
        "tells": "Cosa dicono loro i tuoi contenuti",
        "quoted": "«{quote}»",
        "edit": "Modifica questo obiettivo: {subject}"
      },
      "end": {
        "title": "Pronti a decidere",
        "body": "Hanno ciò che serve per prenderti in considerazione"
      },
      "objectiveDialog": {
        "title": "Modifica questo obiettivo",
        "eyebrow": "{phase} · {subject}"
      },
      "coreMessageDialog": {
        "title": "Modifica il tuo messaggio chiave",
        "description": "Una frase che un acquirente deve accettare prima di sceglierti. Nomina la tua azienda una volta, al massimo {max} parole.",
        "words": "{count} / {max} parole"
      }
    },
    "visualStyle": {
      "choice": {
        "title": "Stile visivo",
        "lead": "Ora definisci l'aspetto del tuo brand per i post sui social. Hai design per cui ti riconoscono? Oppure scegli un modello dalla libreria di Raldo.",
        "ownTitle": "Ho i miei design",
        "ownCaption": "Carica qualche immagine. Raldo ne farà un design riutilizzabile per tutti i contenuti.",
        "templatesTitle": "Mostrami i modelli",
        "templatesCaption": "Scegli un modello e adattalo al tuo stile."
      },
      "templates": {
        "title": "Scegli un modello",
        "lead": "Ogni modello è un set completo di slide per i tuoi caroselli. Te li mostriamo nei tuoi colori, con il tuo logo.",
        "kitLabel": "Il tuo kit di brand",
        "kit": {
          "logo": "Logo",
          "logoMark": "Marchio",
          "colours": "Colori",
          "font": "Font",
          "fontNotSet": "Non impostato",
          "editLogo": "Modifica il logo",
          "editLogoMark": "Modifica il marchio",
          "editColours": "Modifica i colori",
          "editFont": "Modifica il font"
        },
        "colourMode": "Colori mostrati",
        "modeBrand": "I tuoi colori",
        "modeTemplate": "Colori del modello",
        "filterLabel": "Filtra i modelli",
        "filterAll": "Tutti",
        "filterLight": "Chiari",
        "filterDark": "Scuri",
        "ownTitle": "I tuoi design",
        "ownCaption": "Trascina qui qualche post o fai clic per caricare",
        "cover": "Modello {name}",
        "failed": "Raldo non è riuscito a caricare i modelli. Riprova."
      },
      "template": {
        "accent": "Colore di accento",
        "accentFirst": "Il tuo primo colore",
        "fonts": "Font",
        "fontsLabel": "Font del modello",
        "later": "Puoi cambiare il modello più tardi in Stile.",
        "allTemplates": "Tutti i modelli",
        "use": "Usa questo modello"
      },
      "own": {
        "title": "I tuoi design",
        "lead": "Aggiungi post o slide che ti piacciono. Raldo ne ricava un modello con ogni tipo di slide che servono ai tuoi post.",
        "uploadTitle": "I tuoi design",
        "uploadCount": "{count} aggiunti",
        "add": "Aggiungi",
        "design": "Design {n}",
        "noticeTitle": "Raldo crea il tuo modello dopo la configurazione",
        "notice": "Ti avvisiamo quando è pronto.",
        "back": "Indietro",
        "finish": "Termina la configurazione"
      },
      "errors": {
        "strategyMissing": "Conferma prima la tua strategia di contenuti.",
        "designsMissing": "Alcuni dei tuoi design non sono più nella tua libreria media. Aggiungili di nuovo.",
        "roleRequired": "Solo un owner o un admin può confermare questo passaggio."
      }
    }
  },
  "tour": {
    "basics": {
      "composer": {
        "title": "Chiedi il lavoro, non lo strumento",
        "body": "Dimmi \"pianifica la prossima settimana\" o \"analizza un concorrente\" e lo faccio. Scrivo io stesso nella tua bacheca, nei tuoi design e nel tuo brand."
      },
      "nav": {
        "title": "Dove finisce il mio lavoro",
        "body": "In Chat, In arrivo, Bacheca e Visibilità lavori tu. Contenuti raccoglie le tue pagine, i post, la strategia e i media. Brand è ciò che so di te: profilo, stile, concorrenti e conoscenze. Da lì nasce tutto quello che scrivo."
      },
      "dock": {
        "title": "Leggo la schermata in cui sei",
        "body": "Aprimi ovunque con Cmd o Ctrl e J. Vedo il post o il grafico che hai davanti, quindi basta \"riscrivi questo\"."
      },
      "hub": {
        "title": "Ancora, quando vuoi",
        "body": "Ogni tour resta qui se vuoi rivederlo, e puoi disattivare i suggerimenti per sempre."
      }
    },
    "content": {
      "board": {
        "title": "Il tasto destro è la scorciatoia",
        "body": "Pianifica, pubblica ora, duplica ed elimina stanno tutti in quel menu. Un clic singolo apre solo un'anteprima del post accanto a me."
      },
      "plan": {
        "title": "Posso riempire tutto il periodo",
        "body": "Dammi un periodo e pianifico un post per ognuno dei tuoi giorni di pubblicazione dai tuoi argomenti e categorie, poi scrivo le bozze. Si apre il canvas, così le vedi arrivare una accanto all'altra."
      }
    },
    "brand": {
      "foundation": {
        "title": "Da cosa scrivo",
        "body": "Profilo contiene i fatti del tuo marchio e il cliente per cui scrivi. Cambia uno dei due e tutto quello che scrivo dopo lo segue."
      },
      "style": {
        "title": "Come suona e come appare",
        "body": "Voce decide come suonano i tuoi post, Stile visivo come appaiono i tuoi design. Li leggo entrambi dal tuo sito durante la configurazione, e ogni bozza li segue."
      }
    },
    "controls": {
      "next": "Avanti",
      "back": "Indietro",
      "skip": "Salta",
      "done": "Fatto",
      "gotIt": "Ho capito",
      "close": "Chiudi il suggerimento",
      "step": "Passo {index} di {total}"
    },
    "handoff": {
      "title": "Ti va un breve tour?",
      "body": "Quattro brevi tappe: il campo di scrittura, la navigazione, il pannello della chat e questo hub.",
      "accept": "Mostrami in giro",
      "decline": "Non ora"
    },
    "hub": {
      "label": "Mostrami in giro",
      "title": "{done} tour su {total} visti",
      "replay": "Rivedi",
      "start": "Inizia",
      "turnOff": "Disattiva i suggerimenti",
      "turnOn": "Attiva i suggerimenti",
      "allSeen": "Hai visto tutti i tour.",
      "tours": {
        "basics": "Le basi",
        "content": "Contenuti",
        "brand": "Brand"
      }
    }
  },
  "editor": {
    "shell": {
      "closeEditor": "Chiudi editor",
      "designName": "Nome del design",
      "save": "Salva",
      "saving": "Salvataggio in corso",
      "exportPng": "Esporta PNG"
    },
    "canvas": {
      "region": "Canvas",
      "zoomOut": "Riduci zoom",
      "zoomIn": "Aumenta zoom",
      "zoomToFit": "Adatta alla vista",
      "resetZoom": "Ripristina zoom al 100 percento",
      "selectNamed": "Seleziona {name}",
      "selectItem": "Seleziona elemento"
    },
    "export": {
      "exporting": "Esportazione in corso…"
    },
    "border": {
      "title": "Bordo",
      "selectShape": "Seleziona una forma o un testo per aggiungere un bordo.",
      "add": "Aggiungi bordo",
      "color": "Colore del bordo",
      "width": "Spessore del bordo",
      "remove": "Rimuovi bordo"
    },
    "color": {
      "fill": "Colore di riempimento",
      "fillOpacity": "Opacità del riempimento",
      "text": "Colore del testo",
      "background": "Colore di sfondo",
      "noColor": "Questo livello non ha colori da modificare.",
      "none": "Nessun colore",
      "custom": "Personalizzato",
      "customAria": "Colore personalizzato",
      "back": "Indietro",
      "inThisDesign": "In questo design",
      "colorPalette": "Palette colori",
      "defaultColors": "Colori predefiniti",
      "defaultGradients": "Sfumature predefinite",
      "seeAll": "Vedi tutti",
      "solid": "Tinta unita",
      "gradient": "Sfumatura",
      "paintType": "Tipo di riempimento",
      "gradientColors": "Colori sfumatura",
      "style": "Stile",
      "addColor": "Aggiungi colore",
      "removeColor": "Rimuovi colore {number}",
      "colorNumber": "Colore {number}",
      "styleLinear90": "90°",
      "styleLinear180": "180°",
      "styleLinear135": "135°",
      "styleRadialCenter": "Centro",
      "styleRadialCorner": "Angolo",
      "groupCool": "Toni freddi",
      "groupWarm": "Toni caldi",
      "groupMonochromatic": "Monocromatico",
      "groupAll": "Tutte le sfumature",
      "applyGradient": "Sfumatura {number}"
    },
    "common": {
      "advanced": "Avanzate"
    },
    "editImage": {
      "title": "Modifica immagine",
      "selectImage": "Seleziona un'immagine",
      "selectImageHint": "Le regolazioni, la maschera di forma e il ritaglio si applicano a un'immagine selezionata.",
      "replace": "Sostituisci",
      "replaceWith": "Sostituisci con",
      "sectionsAria": "Sezioni di modifica immagine",
      "tabAdjust": "Regola",
      "tabFrame": "Maschera di forma",
      "adjustments": "Regolazioni",
      "brightness": "Luminosità",
      "contrast": "Contrasto",
      "frame": "Maschera di forma",
      "frameShapeAria": "Maschera di forma",
      "frameNone": "Nessuna",
      "frameCircle": "Cerchio",
      "frameRounded": "Arrotondata",
      "frameTriangle": "Triangolo",
      "crop": "Ritaglia",
      "cropAspectRatioAria": "Proporzioni del ritaglio",
      "cropTo": "Ritaglia in {preset}"
    },
    "library": {
      "heading": "La tua libreria",
      "uploadImage": "Carica immagine",
      "upload": "Carica",
      "loading": "Caricamento della libreria in corso",
      "empty": "Nessuna immagine ancora"
    },
    "action": {
      "cut": "Taglia",
      "copy": "Copia",
      "paste": "Incolla",
      "duplicate": "Duplica",
      "duplicateShortcut": "Duplica (⌘D)",
      "deleteShortcut": "Elimina (⌫)",
      "bringToFront": "Porta in primo piano",
      "bringForward": "Porta avanti",
      "sendBackward": "Porta indietro",
      "sendToBack": "Porta sullo sfondo",
      "group": "Raggruppa",
      "ungroup": "Separa gruppo",
      "layerActionsAria": "Azioni sul livello"
    },
    "toolbar": {
      "askRaldo": "Chiedi a Raldo di questo",
      "title": "Strumenti dell'editor",
      "layerSelected": "Un livello è selezionato",
      "noSelection": "Nessuna selezione",
      "undo": "Annulla",
      "undoShortcut": "Annulla (⌘Z)",
      "redo": "Ripeti",
      "redoShortcut": "Ripeti (⇧⌘Z)",
      "addImage": "Aggiungi immagine",
      "addText": "Aggiungi testo",
      "addShape": "Aggiungi forma",
      "addFrame": "Aggiungi cornice",
      "rectangle": "Rettangolo",
      "ellipse": "Ellisse",
      "add": "Aggiungi",
      "lock": "Blocca",
      "unlock": "Sblocca",
      "transparency": "Trasparenza",
      "label": "Etichetta",
      "transparentGround": "Nessun riempimento",
      "clipContents": "Ritaglia contenuto"
    },
    "layout": {
      "title": "Layout automatico",
      "selectFrame": "Seleziona una cornice per disporne il contenuto.",
      "explainer": "Una cornice con layout automatico dispone il proprio contenuto, così un testo più lungo spinge in basso ciò che segue invece di passarci sotto.",
      "enable": "Aggiungi layout automatico",
      "disable": "Rimuovi layout automatico",
      "direction": "Direzione",
      "column": "Colonna",
      "row": "Riga",
      "align": "Allineamento",
      "alignStart": "Inizio",
      "alignCenter": "Centro",
      "alignEnd": "Fine",
      "gap": "Spaziatura",
      "padding": "Margine interno",
      "paddingTop": "Alto",
      "paddingRight": "Destra",
      "paddingBottom": "Basso",
      "paddingLeft": "Sinistra",
      "linkPadding": "Collega tutti i lati",
      "unlinkPadding": "Imposta ogni lato separatamente",
      "justify": "Distribuzione",
      "justifyStart": "Inizio",
      "justifyCenter": "Centro",
      "justifyEnd": "Fine",
      "justifySpaceBetween": "Spazio tra gli elementi",
      "justifySpaceAround": "Spazio attorno",
      "justifySpaceEvenly": "Spazio uniforme",
      "wrap": "A capo",
      "positionOwnedByLayout": "Il layout automatico che contiene questo livello decide dove si trova.",
      "sizingWidth": "Larghezza",
      "sizingHeight": "Altezza",
      "sizingFixed": "Fisso",
      "sizingHug": "Adatta",
      "sizingFill": "Riempi",
      "escapeLayout": "Escludi dal layout",
      "escapeLayoutHint": "Escludi questo livello dal layout automatico che lo contiene. Mantiene la propria posizione, e il layout si dispone come se non ci fosse.",
      "returnToLayoutHint": "Restituisci questo livello al layout automatico che lo contiene."
    },
    "properties": {
      "title": "Proprietà del design",
      "show": "Mostra proprietà",
      "hide": "Nascondi proprietà",
      "close": "Chiudi proprietà",
      "contextText": "Testo",
      "contextImage": "Immagine",
      "contextShape": "Forma",
      "contextFrame": "Cornice",
      "contextPage": "Pagina",
      "contextSelection": "Selezione",
      "format": "Formato",
      "artboardFormat": "Formato dell'artboard",
      "fontSize": "Dimensione del carattere",
      "bold": "Grassetto",
      "italic": "Corsivo",
      "fontFamily": "Famiglia di caratteri",
      "alignLeft": "Allinea a sinistra",
      "alignCenter": "Allinea al centro",
      "alignRight": "Allinea a destra",
      "hugContents": "Adatta al testo",
      "textEffects": "Effetti di testo",
      "effects": "Effetti",
      "labelForRaldo": "Etichetta per Raldo",
      "cornerRounding": "Arrotondamento degli angoli",
      "position": "Posizione",
      "opacity": "Opacità",
      "editingShared": "Stai modificando le proprietà condivise di 1 livello. | Stai modificando le proprietà condivise di {count} livelli."
    },
    "position": {
      "sectionAria": "Sezione del pannello posizione",
      "arrange": "Disponi",
      "layers": "Livelli",
      "forward": "Avanti",
      "backward": "Indietro",
      "toFront": "In primo piano",
      "toBack": "Sullo sfondo",
      "alignToPage": "Allinea alla pagina",
      "top": "Alto",
      "left": "Sinistra",
      "middle": "Centro",
      "center": "Centrato",
      "bottom": "Basso",
      "right": "Destra",
      "sizeAndPosition": "Dimensione e posizione",
      "w": "L",
      "h": "A",
      "x": "X",
      "y": "Y",
      "width": "Larghezza",
      "height": "Altezza",
      "positionX": "Posizione X",
      "positionY": "Posizione Y",
      "rotate": "Ruota",
      "rotationDegrees": "Rotazione in gradi",
      "lockRatio": "Blocca proporzioni",
      "unlockRatio": "Sblocca proporzioni",
      "selectionBoundsHint": "Limiti della selezione. Usa Allinea e distribuisci per posizionare più livelli.",
      "selectLayerHint": "Seleziona un livello per modificarne dimensione e posizione.",
      "group": "Gruppo",
      "distribute": "Distribuisci",
      "horizontal": "Orizzontale",
      "vertical": "Verticale",
      "noLayers": "Nessun livello ancora",
      "renameLayer": "Rinomina livello",
      "moveForward": "Sposta livello avanti",
      "moveBackward": "Sposta livello indietro",
      "toggleVisibility": "Attiva/disattiva visibilità del livello",
      "toggleLock": "Attiva/disattiva blocco del livello",
      "collapseLayer": "Comprimi livello",
      "expandLayer": "Espandi livello"
    },
    "opacity": {
      "selectLayer": "Seleziona un livello per regolarne l'opacità."
    },
    "page": {
      "sectionAria": "Sezione del pannello pagina",
      "forRaldo": "Per Raldo",
      "textRaldoWrites": "Testo che scrive Raldo",
      "picturesRaldoAsksFor": "Immagini che chiede Raldo",
      "notLabelled": "Senza etichetta",
      "noSlots": "Su questa pagina non c’è ancora nulla etichettato per Raldo. Seleziona un livello di testo o immagine e assegnagli un’etichetta.",
      "emptySlot": "Vuoto",
      "charLimit": "Limite: {count} caratteri",
      "add": "Aggiungi pagina",
      "delete": "Elimina pagina",
      "duplicate": "Duplica pagina",
      "moveLeft": "Sposta la pagina a sinistra",
      "moveRight": "Sposta la pagina a destra"
    },
    "text": {
      "uppercase": "Maiuscolo",
      "spacing": "Spaziatura",
      "letterSpacing": "Spaziatura lettere",
      "lineSpacing": "Interlinea",
      "anchor": "Ancora casella di testo",
      "anchorTop": "Cresce verso il basso",
      "anchorMiddle": "Cresce dal centro",
      "anchorBottom": "Cresce verso l’alto",
      "anchorHint": "Quale bordo resta fermo quando il testo si allunga o si accorcia.",
      "selectText": "Seleziona un livello di testo per impostarne la spaziatura."
    },
    "background": {
      "title": "Sfondo",
      "detach": "Stacca",
      "remove": "Rimuovi sfondo"
    },
    "panel": {
      "collapse": "Comprimi pannello",
      "expand": "Espandi pannello"
    },
    "textEffects": {
      "selectLayer": "Seleziona un livello di testo",
      "selectLayerHint": "Gli effetti di testo si applicano a un livello di testo selezionato.",
      "addBackground": "Aggiungi sfondo al testo",
      "background": "Sfondo del testo",
      "removeBackground": "Rimuovi sfondo del testo",
      "backgroundColor": "Colore di sfondo",
      "backgroundRoundness": "Arrotondamento dello sfondo",
      "padding": "Spaziatura interna",
      "backgroundOpacity": "Opacità dello sfondo",
      "none": "Nessuno",
      "backgroundTile": "Sfondo",
      "specimen": "Ag",
      "roundness": "Arrotondamento",
      "opacity": "Opacità"
    },
    "nodeEffects": {
      "selectLayer": "Seleziona un livello",
      "selectLayerHint": "Gli effetti si applicano al livello selezionato.",
      "none": "Nessuno",
      "shadowTile": "Ombra",
      "shadow": "Ombra",
      "distance": "Distanza",
      "direction": "Direzione",
      "softness": "Morbidezza",
      "spread": "Espansione",
      "shadowColor": "Colore dell’ombra",
      "shadowOpacity": "Opacità dell’ombra"
    },
    "insert": {
      "title": "Inserisci",
      "back": "Indietro",
      "tabsAria": "Cosa inserire",
      "scrollTabsPrev": "Scorri a sinistra",
      "scrollTabsNext": "Scorri a destra",
      "tabTemplates": "Modelli",
      "tabElements": "Elementi",
      "tabImages": "Immagini",
      "tabText": "Testo",
      "tabShapes": "Forme",
      "kind": {
        "background": "Sfondi",
        "shape": "Forme",
        "separator": "Separatori",
        "decoration": "Decorazioni"
      },
      "noTemplates": "Ancora nessun modello.",
      "noElements": "Ancora nessun elemento.",
      "applyTemplate": "Applica il modello {name} a questa pagina",
      "appendTemplate": "Aggiungi il modello {name} come nuova pagina",
      "openTemplate": "Apri il modello {name}",
      "applyAllPages": "Applica tutte le {count} pagine",
      "applyTemplatePage": "Applica la pagina {number} a questa pagina",
      "templateMeta": "{width} × {height} px · {count} pagine",
      "templatePages": "{count} pagine",
      "placeElement": "Aggiungi l’elemento {name}",
      "addHeading": "Aggiungi titolo",
      "addSubheading": "Aggiungi sottotitolo",
      "shapesHint": "Una cornice raggruppa ciò che ci metti dentro e può disporlo per te.",
      "elementSaved": "Salvato come elemento.",
      "elementSaveFailed": "Non è stato possibile salvare l’elemento.",
      "elementRenameFailed": "Non è stato possibile rinominare l’elemento.",
      "elementDeleteFailed": "Non è stato possibile eliminare l’elemento.",
      "saveAsElement": "Salva come elemento",
      "saveElementBody": "Conserva questa selezione per inserirla in qualsiasi design.",
      "elementName": "Nome",
      "elementNamePlaceholder": "Alone blu",
      "elementKind": "Gruppo",
      "elementBleed": "Copri tutta la pagina",
      "elementBleedHint": "Un elemento che copre si adatta alla pagina e finisce dietro a tutto ciò che c’è già."
    },
    "cornerRadius": {
      "selectLayer": "Seleziona una forma, un'immagine o una cornice per regolarne l'arrotondamento degli angoli.",
      "value": "Valore dell'arrotondamento degli angoli"
    },
    "slotLabel": {
      "selectLayer": "Seleziona un livello di testo o immagine",
      "selectLayerHint": "L'etichetta dice a Raldo cos'è un campo e come compilarlo.",
      "addLabel": "Aggiungi etichetta",
      "removeLabel": "Rimuovi etichetta",
      "role": "Ruolo",
      "roleHint": "Nome breve in kebab-case, es. page-title",
      "limitLength": "Limita lunghezza",
      "maxLength": "Lunghezza massima"
    },
    "generating": {
      "drafting": "Bozza in corso"
    },
    "conflict": {
      "title": "Questo design è stato modificato altrove",
      "description": "Qualcun altro ha salvato modifiche a questo design dopo che lo hai aperto. Le tue modifiche locali sono ancora qui, ma salvare di nuovo continuerà a fallire finché non ricarichi. Ricarica per caricare l'ultima versione, oppure continua a modificare e ricarica prima di provare a salvare.",
      "keepEditing": "Continua a modificare",
      "reload": "Ricarica"
    },
    "view": {
      "loading": "Caricamento di questo design in corso",
      "notFound": "Design non trovato",
      "backToMedia": "Torna a Media",
      "draftingToast": "Raldo sta scrivendo la bozza del tuo post.",
      "discardTitle": "Scartare le modifiche non salvate?",
      "discardDescription": "Questo design contiene modifiche non salvate. Uscendo ora andranno perse.",
      "unsavedChanges": "Questo design contiene modifiche non salvate."
    },
    "defaults": {
      "text": "Testo",
      "image": "Immagine",
      "frame": "Cornice",
      "ellipse": "Ellisse",
      "rectangle": "Rettangolo",
      "artboard": "Artboard",
      "pageNumber": "Pagina {number}"
    },
    "format": {
      "square": "Quadrato",
      "portrait": "Verticale",
      "story": "Storia"
    },
    "crop": {
      "presetOriginal": "Originale",
      "preset1x1": "1:1",
      "preset4x5": "4:5",
      "preset16x9": "16:9",
      "preset9x16": "9:16"
    }
  },
  "primitives": {
    "loading": "Caricamento in corso",
    "breadcrumb": {
      "ariaLabel": "Breadcrumb",
      "moreAriaLabel": "Mostra le cartelle intermedie"
    },
    "dateTimePicker": {
      "setDateTime": "Imposta data e ora",
      "setDates": "Imposta le date",
      "previousMonth": "Mese precedente",
      "nextMonth": "Mese successivo",
      "time": "Orario",
      "hour": "Ora",
      "minute": "Minuto",
      "set": "Imposta"
    },
    "dropzone": {
      "dragDropTitle": "Trascina qui i file",
      "clickToBrowse": "oppure clicca per sfogliare",
      "triggerAriaLabel": "{title}. {subtitle}",
      "filesSelected": "1 file selezionato | {count} file selezionati",
      "filesSelectedWithIgnored": "1 file selezionato, {ignored} ignorato (tipo non supportato) | {count} file selezionati, {ignored} ignorati (tipo non supportato)"
    },
    "expandableText": {
      "showMore": "Mostra di più",
      "showLess": "Mostra di meno"
    },
    "field": {
      "required": "(Obbligatorio)",
      "optional": "(Facoltativo)"
    },
    "keyboard": {
      "controlKey": "Ctrl"
    },
    "languageSelect": {
      "ariaLabel": "Lingua: {language}"
    },
    "markdownEditor": {
      "editorLabel": "Editor Markdown",
      "askRaldo": "Chiedi a Raldo",
      "bold": "Grassetto",
      "italic": "Corsivo",
      "strikethrough": "Barrato",
      "heading": "Titolo",
      "bulletList": "Elenco puntato",
      "numberedList": "Elenco numerato",
      "quote": "Citazione",
      "link": "Link",
      "linkText": "testo del link",
      "url": "url",
      "toggleTask": "Attiva/disattiva attività",
      "textFormatting": "Formattazione del testo",
      "selectionFormatting": "Formattazione della selezione",
      "insertBlock": "Inserisci blocco",
      "hookBoundaryLabel": "Primi {count} caratteri visibili nel feed"
    },
    "numberInput": {
      "decrement": "Diminuisci",
      "increment": "Aumenta"
    },
    "toast": {
      "close": "Chiudi"
    },
    "toaster": {
      "notifications": "Notifiche"
    },
    "chart": {
      "noData": "Nessun dato per questo periodo",
      "labelValue": "{label}: {value}",
      "valueCaption": "{value} · {caption}",
      "fractionSr": "{value} su {total} {label}",
      "rank": "#{rank}",
      "axisRangeSr": "Asse orizzontale da {xLow} a {xHigh}, asse verticale da {yLow} a {yHigh}",
      "pointSr": "{label} - orizzontale {x} di 100, verticale {y} di 100",
      "bubbleSr": "{label}: {xLabel} {x}, {yLabel} {y}",
      "bubbleAxesSummary": "{xLabel} {x}, {yLabel} {y}",
      "seriesLabelValue": "{series}, {label}: {value}",
      "seriesValues": "{series}: {values}"
    },
    "delta": {
      "percent": "{value}%",
      "points": "{value} pt",
      "absolute": "{value}",
      "unchanged": "invariato"
    },
    "colorInput": {
      "brandColor": "Colore del brand",
      "hexValue": "Valore hex di {label}"
    },
    "colorPicker": {
      "square": "Saturazione e luminosità",
      "hue": "Tonalità",
      "opacity": "Opacità",
      "hex": "Colore esadecimale"
    },
    "aiEngine": {
      "chatgpt": "ChatGPT",
      "perplexity": "Perplexity",
      "google": "Panoramica AI di Google"
    }
  },
  "revisionHistory": {
    "loading": "Caricamento della cronologia in corso",
    "generated": "{author} ha generato questa versione.",
    "edited": "{author} l'ha modificata.",
    "rewritten": "{author} l'ha riscritta.",
    "restored": "{author} ha ripristinato una versione precedente.",
    "instructionAsked": "Hai chiesto: \"{instruction}\"",
    "current": "Attuale",
    "restore": "Ripristina",
    "restoreAria": "Ripristina la versione del {date}"
  },
  "knowledge": {
    "searchPlaceholder": "Cerca nella conoscenza",
    "noMatches": "Nessuna pagina corrisponde.",
    "newPage": "Nuova pagina",
    "loading": "Caricamento della tua conoscenza in corso",
    "loadError": "Non è stato possibile caricare la tua conoscenza",
    "emptyTitle": "Non hai ancora scritto niente",
    "emptyBody": "Le pagine di conoscenza contengono cosa è vero del tuo prodotto: cosa fa, quanto costa, chi lo compra. Raldo ci attinge ogni volta che scrive un post.",
    "askRaldo": "Chiedi a Raldo di leggere il tuo sito",
    "askRaldoToRead": "Leggi il mio sito e scrivi cosa fa il mio prodotto, quanto costa e chi lo compra.",
    "titleLabel": "Titolo della pagina",
    "titlePlaceholder": "Di cosa parla questa pagina?",
    "bodyLabel": "Corpo della pagina",
    "bodyPlaceholder": "Scrivi cosa è vero del tuo prodotto.",
    "outlineLabel": "Indice della pagina",
    "writtenFrom": "Scritto da",
    "historyLabel": "Cronologia",
    "notFoundTitle": "Questa pagina non esiste",
    "notFoundBody": "Potrebbe essere stata eliminata, oppure il link è sbagliato.",
    "backToLibrary": "Torna a Conoscenze",
    "deleteTitle": "Eliminare questa pagina?",
    "deleteBody": "La pagina e tutta la sua cronologia spariscono per sempre, e Raldo smette di attingerci.",
    "reading": "Lettura di {site} in corso",
    "readingBatch": "gruppo {done} di {total}",
    "readingPages": "{selected} pagine su {found}, scelte in base a cosa colleghi dalla tua home.",
    "bucket": {
      "productsAndServices": "Prodotti e servizi",
      "pricing": "Prezzi",
      "customersAndBuyers": "Clienti e acquirenti",
      "howItWorks": "Come funziona"
    },
    "foldersHeading": "Cartelle",
    "pagesHeading": "Pagine",
    "newFolder": "Nuova cartella",
    "newFolderTitle": "Nuova cartella",
    "renameFolder": "Rinomina",
    "renameFolderTitle": "Rinomina cartella",
    "folderNameLabel": "Nome della cartella",
    "folderNamePlaceholder": "Cosa ci metti dentro?",
    "folderNameTaken": "Una cartella qui si chiama già così.",
    "folderNameTooLong": "Tieni il nome entro {count} caratteri.",
    "folderCreate": "Crea",
    "folderCount": "1 cartella | {count} cartelle",
    "pageCount": "1 pagina | {count} pagine",
    "folderEmpty": "Vuota",
    "folderEmptyTitle": "In questa cartella non c'è ancora niente",
    "folderEmptyBody": "Scrivi una pagina qui, oppure trascinacene una da altrove.",
    "moveAction": "Sposta in una cartella…",
    "moveTitle": "Sposta in una cartella",
    "moveBody": "Scegli dove va.",
    "moveConfirm": "Sposta",
    "itemActions": "Azioni per {name}",
    "itemActionsMenu": "Azioni",
    "deleteFolderTitle": "Eliminare questa cartella?",
    "deleteFolderBody": "La cartella sparisce. Tutto quello che contiene sale nella cartella sopra, quindi non perdi niente.",
    "slugTakenTitle": "Esiste già una pagina con questo titolo.",
    "slugTakenAction": "Aprila",
    "toast": {
      "saveFailed": "Non è stato possibile salvare la pagina",
      "restoreFailed": "Non è stato possibile ripristinare questa versione",
      "deleteFailed": "Non è stato possibile eliminare la pagina",
      "folderCreateFailed": "Non è stato possibile creare la cartella",
      "folderRenameFailed": "Non è stato possibile rinominare la cartella",
      "folderDeleteFailed": "Non è stato possibile eliminare la cartella",
      "moveFailed": "Non è stato possibile spostare l'elemento"
    },
    "openFullPage": "Apri la pagina intera",
    "morePages": "1 in più | {count} in più",
    "preview": {
      "openFull": "Apri la pagina intera",
      "close": "Chiudi anteprima",
      "askPlaceholder": "Chiedi a Raldo di questa pagina"
    },
    "unsavedChanges": "Questa pagina ha modifiche non salvate."
  },
  "quickLook": {
    "loading": "Caricamento dell'anteprima",
    "unavailable": "Impossibile caricare questa immagine",
    "previous": "Elemento precedente",
    "next": "Elemento successivo",
    "position": "{index} di {count}",
    "close": "Chiudi anteprima"
  },
  "design": {
    "view": {
      "loading": "Caricamento del design",
      "notFoundTitle": "Design non trovato",
      "notFoundDescription": "Questo design potrebbe essere stato eliminato.",
      "attachAction": "Allega a un post",
      "backToPost": "Torna al post",
      "documentError": "Non è stato possibile leggere il file del design. Riprova."
    },
    "page": {
      "loading": "Caricamento della pagina {page}",
      "error": "Impossibile caricare questa pagina",
      "alt": "Pagina {page}"
    },
    "carousel": {
      "label": "Pagine del design",
      "previous": "Pagina precedente",
      "next": "Pagina successiva",
      "status": "Pagina {page} di {count}"
    },
    "status": {
      "loading": "Caricamento della cronologia",
      "running": "Raldo sta creando il design. Servono pochi secondi.",
      "completed": "Il design è pronto.",
      "failed": "Non è stato possibile creare il design. {reason}",
      "reasons": {
        "design_run_enqueue_failed": "Non è partito. Riprova.",
        "design_run_failed": "Qualcosa è andato storto. Riprova.",
        "design_render_failed": "Non è stato possibile disegnare le pagine. Riprova.",
        "design_attach_failed": "Non è stato possibile aggiungerlo al post. Riprova.",
        "run_timed_out": "Ci ha messo troppo. Riprova.",
        "unknown": "Riprova."
      }
    },
    "attachToPost": {
      "title": "Allega a un post",
      "description": "Scegli una bozza a cui questo design diventerà l'artwork.",
      "emptyTitle": "Ancora nessuna bozza",
      "emptyDescription": "Crea prima una bozza, poi allega questo design.",
      "untitled": "Post senza titolo",
      "confirm": "Allega",
      "attaching": "Allegando",
      "success": "Design allegato al post"
    },
    "runBadge": {
      "running": "In creazione",
      "failed": "Non riuscito"
    },
    "editor": {
      "errorTitle": "Impossibile aprire il design",
      "frameTitle": "Pagina {page}",
      "pages": {
        "summary": "{count} pagina · Verticale 4:5 | {count} pagine · Verticale 4:5",
        "label": "Pagine",
        "item": "Pagina {page}, {layout}",
        "moveUp": "Sposta la pagina in alto",
        "moveDown": "Sposta la pagina in basso",
        "duplicate": "Duplica la pagina",
        "delete": "Elimina la pagina",
        "add": "Aggiungi una pagina"
      },
      "canvas": {
        "label": "Pagina del design",
        "page": "Pagina {page}",
        "previous": "Pagina precedente",
        "next": "Pagina successiva",
        "position": "{page} / {count}"
      },
      "inspector": {
        "page": "Pagina {page}",
        "groups": {
          "argument": "Layout di argomentazione da {template}",
          "announcement": "Layout di annuncio da {template}",
          "brand": "Layout del brand da {template}"
        },
        "editTitle": "Modifica qualsiasi cosa nella pagina",
        "editBody": "Clicca su un testo, un'immagine o una forma nella pagina per darle stile, spostarla o cambiarla.",
        "copyTitle": "Questo design è una copia a sé",
        "copyBody": "Le modifiche restano in questo design. Non toccano mai il tuo stile del brand né il template.",
        "title": "Ispettore",
        "change": "Cambia",
        "pageColour": "Colore della pagina",
        "designColours": "Colori del design",
        "fonts": {
          "headings": "Font dei titoli",
          "text": "Font del testo"
        },
        "text": "Testo",
        "weight": "Spessore",
        "weights": {
          "w400": "Regolare",
          "w500": "Medio",
          "w600": "Semigrassetto",
          "w700": "Grassetto",
          "w800": "Extra grassetto"
        },
        "case": "Maiuscole",
        "cases": {
          "none": "Normale",
          "uppercase": "Maiuscolo"
        },
        "colour": "Colore",
        "picture": "Immagine",
        "position": "Posizione",
        "x": "X",
        "y": "Y",
        "width": "Larghezza",
        "rotation": "Rotazione",
        "appearance": "Aspetto",
        "opacity": "Opacità",
        "arrange": "Disponi",
        "forward": "Porta avanti",
        "backward": "Porta indietro",
        "duplicate": "Duplica",
        "delete": "Elimina",
        "reset": "Ripristina il layout",
        "kind": {
          "slot": "Raldo l'ha scritto dal post. Se cambi le parole qui, cambia anche il testo del post. Lo stile e la posizione che scegli restano.",
          "part": "Parte del layout {template}. Modificane lo stile, spostala o rimuovila; Raldo la lascia come l'hai impostata.",
          "free": "L'hai aggiunto tu, solo su questa pagina. Raldo lo lascia come l'hai impostato."
        },
        "slidesDiffer": "Il post e questo design hanno slide diverse."
      },
      "layouts": {
        "title": "Titolo",
        "statement": "Affermazione",
        "statement-2": "Affermazione 2",
        "statement-3": "Affermazione 3",
        "stat": "Dato",
        "quote": "Citazione",
        "contrast": "Contrasto",
        "example": "Esempio",
        "takeaway": "Conclusione",
        "product": "Prodotto",
        "features": "Funzionalità",
        "service": "Servizio",
        "included": "Incluso",
        "person": "Persona",
        "event": "Evento",
        "sign-off": "Chiusura"
      },
      "save": {
        "saved": "Salvato",
        "saving": "Salvataggio",
        "failed": "Salvataggio non riuscito",
        "stale": "Modificato altrove",
        "reload": "Ricarica",
        "failedToast": "Non è stato possibile salvare il design",
        "staleToast": "Questo design è stato modificato altrove. Ricarica per continuare a modificare.",
        "refused": {
          "invalid": "Il file del design non è valido.",
          "styles": "Gli stili del design non si possono modificare qui.",
          "editorRole": "Solo chi ha il ruolo di editor può modificare questo design."
        }
      },
      "history": {
        "undo": "Annulla",
        "redo": "Ripeti"
      },
      "slots": {
        "eyebrow": "Occhiello",
        "headline": "Titolo",
        "subhead": "Sottotitolo",
        "bridge": "Raccordo",
        "cue": "Richiamo",
        "images": "Immagine",
        "body": "Testo",
        "value": "Valore",
        "label": "Etichetta",
        "quote": "Citazione",
        "attribution": "Fonte",
        "before": "Prima",
        "after": "Dopo",
        "close": "Riga finale",
        "next": "Passo successivo",
        "action": "Azione",
        "name": "Nome",
        "rows": "Elenco",
        "role": "Ruolo",
        "line": "Riga",
        "date": "Data",
        "place": "Luogo",
        "what": "Cosa",
        "logo": "Logo",
        "brandName": "Nome del brand",
        "tagline": "Slogan",
        "pageCounter": "Numero di pagina"
      },
      "parts": {
        "picture": "Immagine",
        "text": "Testo",
        "shape": "Forma"
      },
      "toasts": {
        "undo": "Annulla",
        "slotRemoved": "{name} rimosso da questa pagina. Raldo non lo scriverà più qui.",
        "duplicated": "Duplicato. La copia è un elemento libero, quindi Raldo non la riempirà di nuovo.",
        "layoutChanged": "Passato a {layout}. I testi sono finiti nei campi adatti; le modifiche libere su questa pagina sono rimaste indietro.",
        "slotSaved": "Salvato. Anche il testo del post alla pagina {page} è cambiato.",
        "pageDeleted": "Pagina eliminata."
      },
      "panels": {
        "label": "Pannello sinistro",
        "pages": "Pagine",
        "insert": "Inserisci"
      },
      "toolbar": {
        "label": "Strumenti della pagina",
        "typing": "Stai scrivendo in {name}",
        "done": "Fatto",
        "insert": "Inserisci",
        "pageColour": "Colore della pagina",
        "changeLayout": "Cambia layout",
        "font": "Font",
        "size": "Dimensione",
        "textColour": "Colore del testo",
        "colour": "Colore",
        "bold": "Grassetto",
        "capitals": "Maiuscolo",
        "alignment": "Allineamento",
        "alignLeft": "Allinea a sinistra",
        "alignCenter": "Allinea al centro",
        "alignRight": "Allinea a destra",
        "replace": "Sostituisci",
        "askRaldo": "Chiedi a Raldo"
      },
      "colours": {
        "accent": "Accento",
        "ground": "Fondo",
        "ink": "Inchiostro",
        "surface": "Superficie",
        "layout": "Usa il colore del layout"
      },
      "pictures": {
        "numbered": "Immagine {number}",
        "none": "Questo design non contiene ancora immagini."
      },
      "insert": {
        "label": "Inserisci",
        "text": "Testo",
        "heading": "Titolo",
        "subheading": "Sottotitolo",
        "body": "Testo del corpo",
        "headingSample": "Titolo",
        "subheadingSample": "Sottotitolo",
        "bodySample": "Testo del corpo",
        "pieces": "Elementi",
        "artwork": "Grafica",
        "shapes": {
          "pointer": "Puntatore",
          "rectangle": "Rettangolo",
          "circle": "Cerchio",
          "line": "Linea",
          "tape": "Striscia di nastro"
        },
        "icons": "Icone",
        "pictures": "Immagini",
        "brand": "Brand",
        "logo": "Logo",
        "brandName": "Nome del brand"
      },
      "picker": {
        "addTitle": "Aggiungi una pagina",
        "changeTitle": "Cambia layout",
        "addDescription": "Scegli un layout. La nuova pagina va dopo questa.",
        "changeDescription": "Scegli un layout per questa pagina. Le parole passano negli spazi adatti.",
        "label": "Layout",
        "card": "{layout}, {group}",
        "now": "Attuale",
        "groups": {
          "argument": "Argomentazione",
          "announcement": "Annuncio",
          "brand": "Brand"
        }
      },
      "fit": {
        "count": "{n} avviso | {n} avvisi",
        "title": "Un elemento non sta nello spazio | {n} elementi non stanno nello spazio",
        "note": "La pagina viene salvata comunque. Correggilo a mano, oppure selezionalo e chiedi a Raldo di adattarlo.",
        "hint": "Accorcia o riduci il testo, spostalo, oppure lascia che lo adatti Raldo.",
        "ask": "Chiedi a Raldo di adattarlo",
        "reasons": {
          "cut-off": "Il testo è tagliato",
          "footer": "Invade il piè di pagina",
          "overlap": "Si sovrappone a {element}",
          "edge": "Esce dal margine della pagina"
        }
      },
      "raldo": {
        "chipPage": "Pagina {page}",
        "startFailed": "Raldo non è riuscito ad avviare la modifica",
        "stopFailed": "Non è stato possibile fermare la modifica",
        "undoFailed": "Non è stato possibile annullare la modifica",
        "refused": {
          "alreadyActive": "Raldo sta già modificando questo design.",
          "notReady": "Questo design non è ancora pronto per essere modificato.",
          "instructionEmpty": "Dì cosa cambiare.",
          "instructionTooLong": "È troppo lungo. Resta sotto i 1000 caratteri.",
          "pageMissing": "Questa pagina non esiste più.",
          "elementMissing": "Questo elemento non è più nella pagina.",
          "editorRole": "Solo gli editor possono modificare un design.",
          "superseded": "Il design è cambiato da allora. Questa modifica non si può più annullare.",
          "notUndoable": "Questa modifica non si può annullare.",
          "snapshotIncomplete": "La copia precedente alla modifica è incompleta.",
          "snapshotUnavailable": "La copia precedente alla modifica non è disponibile."
        },
        "lock": {
          "title": "Raldo sta modificando la pagina {page}",
          "note": "L'editor si sblocca quando ha finito.",
          "stop": "Ferma"
        },
        "steps": {
          "read": "Lettura della pagina {page}",
          "edit": "Modifica di {element}",
          "editPage": "Modifica della pagina",
          "check": "Controllo del risultato"
        },
        "card": {
          "elementFallback": "elemento",
          "undo": "Annulla",
          "undone": "Annullata",
          "undoSuperseded": "Una modifica successiva ha sostituito questa.",
          "cancelled": "Fermata. Non è cambiato nulla.",
          "rejected": "La modifica non ha superato i controlli. Non è cambiato nulla.",
          "timedOut": "La modifica ha richiesto troppo tempo. Non è cambiato nulla.",
          "failed": "La modifica non è riuscita. Non è cambiato nulla."
        }
      }
    },
    "brandStyle": {
      "make": "Crea stile del brand",
      "building": {
        "label": "Creazione dello stile · {done} di {total}",
        "title": "Ancora in creazione",
        "body": "Raldo sta ancora creando lo stile del tuo brand. {done} layout su {total} sono pronti. Continua a lavorare; riceverai un messaggio nella posta in arrivo quando sarà pronto.",
        "confirm": "Ho capito"
      },
      "review": {
        "action": "Controlla stile del brand",
        "title": "Nuovo stile del brand",
        "description": "Disegnato da {design}",
        "pass": "{done} su {total} superano i controlli",
        "footer": "Il testo ci sta, i margini reggono e i colori sono leggibili su ogni layout.",
        "use": "Usa come stile del brand",
        "discard": "Scarta",
        "label": "I layout del nuovo stile del brand",
        "loading": "Caricamento del nuovo stile del brand",
        "loadError": "Impossibile caricare il nuovo stile del brand"
      },
      "dialog": {
        "title": "Crea uno stile del brand da questo design",
        "description": "Raldo trasforma questo design nei 16 layout che usa il tuo brand.",
        "confirm": "Crea in background",
        "steps": {
          "read": "Raldo legge l'aspetto: colori, caratteri e i tuoi stili di testo.",
          "draw": "Disegna i 16 layout in background. Puoi continuare a lavorare. La posta in arrivo ti dice quando è pronto.",
          "check": "Ogni layout viene controllato prima: il testo deve starci, i margini devono reggere, i colori devono essere leggibili."
        },
        "note": "I nuovi design usano il nuovo stile. Questo design e quelli che hai già creato restano come sono."
      },
      "toast": {
        "started": "Raldo sta creando lo stile del tuo brand",
        "startedBody": "Riceverai un messaggio nella posta in arrivo quando sarà pronto.",
        "startFailed": "Impossibile avviare lo stile del brand",
        "use": "Stile del brand aggiornato",
        "useBody": "I nuovi design lo usano. I design esistenti restano come sono.",
        "discard": "Stile del brand scartato",
        "discardBody": "Il tuo stile del brand attuale resta.",
        "decideFailed": "Impossibile salvare la tua scelta"
      },
      "refused": {
        "role": "Solo un proprietario o un amministratore può cambiare lo stile del brand.",
        "active": "Raldo sta già creando uno stile del brand.",
        "designNotReady": "Questo design non è ancora pronto.",
        "notPending": "Su questo stile del brand hai già deciso.",
        "candidateMissing": "Il nuovo stile del brand non c'è più. Crealo di nuovo."
      }
    }
  },
  "tabs": {
    "all": "Tutti",
    "brandFacts": "Fatti del marchio",
    "customerProfile": "Profilo cliente",
    "account": "Account",
    "billing": "Fatturazione",
    "rankings": "Posizionamenti",
    "aiAnswers": "Risposte IA",
    "socialMedia": "Social Media",
    "inbox": "In arrivo",
    "sent": "Inviati",
    "archive": "Archivio"
  },
  "visibility": {
    "search": {
      "pages": {
        "title": "Le tue pagine su Google",
        "source": "Dall'analisi di ricerca mensile",
        "columns": {
          "page": "Pagina",
          "visits": "Visite/mese",
          "keywords": "Keyword"
        },
        "topKeyword": "Keyword principale: {keyword}",
        "emptyTitle": "Ancora nessuna pagina su Google",
        "emptyBody": "L'analisi di ricerca mensile elenca le pagine del tuo sito che Google posiziona, con le visite di ciascuna."
      },
      "columns": {
        "status": "Stato",
        "mainKeyword": "Parola chiave principale"
      },
      "emptyTitle": "Ancora nessuna pagina pianificata",
      "emptyBody": "Quando Raldo pianifica le tue pagine, qui trovi la parola chiave principale di ogni pagina, le sue ricerche e la tua posizione su Google.",
      "openPlan": "Apri il piano"
    },
    "keyword": {
      "why": "Perché puoi vincerla",
      "in": "in",
      "rankHistory": "Posizione nella ricerca nel tempo",
      "weekly": "Settimanale",
      "volume": "Ricerche al mese",
      "volumeSource": "Ultimi 12 mesi, da Google",
      "whoRanks": "Chi è in classifica su Google",
      "aiOverview": "Chi cita l'AI Overview di Google",
      "checked": "Verificato il {date}",
      "searchRun": "Ricerca del {date}"
    },
    "citeHelp": {
      "label": "Cosa significano citato e nominato",
      "cited": "Citato",
      "citedBody": "La risposta collega il sito come fonte. L'acquirente può aprirlo, e la ricerca AI lo conta come prova.",
      "named": "Nominato",
      "namedBody": "La risposta nomina il brand, con o senza link. Ti mette nella mente dell'acquirente ma non porta visite."
    },
    "aiAnswers": {
      "figures": {
        "cited": "Prompt in cui gli assistenti AI ti citano",
        "citeYou": "ti citano",
        "citeRival": "citano invece un concorrente",
        "citeNone": "non citano nessuno che segui",
        "named": "Prompt in cui ti nominano",
        "nameAndLink": "ti nominano e ti collegano",
        "nameNoLink": "ti nominano senza link",
        "nameNone": "non ti nominano mai",
        "overview": "Keyword in cui le AI Overview ti citano",
        "overviewCites": "ti citano",
        "overviewWithout": "rispondono senza di te",
        "overviewNone": "senza AI Overview"
      },
      "prompt": "Prompt",
      "citedBy": "Citato da {engine}",
      "noAnswer": "Nessuna risposta",
      "overviews": "Google AI Overviews",
      "overviewsMeta": "Keyword in cui l'Overview cita te o un concorrente",
      "overviewsEmptyTitle": "Ancora nessuna AI Overview cita te o un concorrente",
      "overviewsEmptyBody": "Quando l'AI Overview di Google per una tua keyword cita te o un concorrente che segui, la keyword compare qui.",
      "emptyTitle": "Ancora nessuna risposta AI",
      "emptyBody": "Una volta al mese Raldo pone a ChatGPT e Perplexity le domande che fanno i tuoi acquirenti, scritte dal tuo piano. Misura ora per ottenere le prime risposte.",
      "run": {
        "working": "Raldo sta misurando la tua visibilità nelle risposte IA.",
        "stages": {
          "prompts": "Raldo sta scrivendo le domande che i tuoi acquirenti pongono agli assistenti IA.",
          "answers": "Raldo sta interrogando gli assistenti IA e leggendo le loro risposte.",
          "commit": "Raldo sta salvando le risposte."
        },
        "completed": "Le risposte IA sono pronte.",
        "partial": "Le risposte IA sono pronte, ma alcune non sono arrivate.",
        "cancelled": "Hai annullato la misurazione.",
        "failed": "La misurazione si è fermata"
      },
      "measure": "Misura ora",
      "table": {
        "title": "Tu e i tuoi rivali nelle risposte IA",
        "meta": "Prompt di argomento e categoria · {period}",
        "share": "Quota dei monitorati",
        "shareHint": "Quota dei nomi che le risposte IA danno a te e ai rivali monitorati",
        "named": "Nominato",
        "cited": "Citato",
        "namedBy": "{engine} nominato",
        "citedBy": "{engine} citato",
        "answers": "{count} risposta | {count} risposte"
      },
      "rates": {
        "answers": "Risposte",
        "byTopic": "Tasso di menzione per argomento",
        "topicMeta": "Solo prompt di argomento · {period}",
        "topic": "Argomento",
        "byStage": "Tasso di menzione per fase",
        "stageMeta": "Prompt di argomento e categoria · {period}",
        "stage": "Fase"
      },
      "otherBrands": {
        "title": "Altre marche nominate",
        "meta": "Da ChatGPT, quota delle sue risposte",
        "brand": "Marca",
        "share": "Quota"
      },
      "domains": {
        "title": "Domini più citati",
        "topicTitle": "Domini più citati: {topic}",
        "meta": "Risposte che citano il sito",
        "site": "Sito"
      },
      "categoryPrompts": "Prompt di categoria",
      "brandPrompts": "Prompt di marca",
      "brandMeta": "Il tuo sito è una fonte in {cited} di {answers} risposte. Non nei dati sopra.",
      "promptCount": "{count} prompt | {count} prompt"
    },
    "prompt": {
      "asked": "· chiesto il {date}",
      "answerFrom": "Risposta di {engine}",
      "cites": "Cita",
      "webSearch": "{model} · ricerca web",
      "noAnswer": "Nessuna risposta questa volta. Raldo chiede di nuovo nell'esecuzione del mese prossimo.",
      "moreSources": "{domain} +{count}",
      "sources": "{count} fonte | {count} fonti",
      "mentions": "Chi menzionano le risposte",
      "mentionsCount": "{count} sito o brand | {count} siti e brand",
      "siteOrBrand": "Sito o brand",
      "mentionsEmpty": "Nessuna delle due risposte menziona un sito o un brand.",
      "you": "Tu",
      "trackedRival": "{domain} · concorrente seguito",
      "site": "Sito, non seguito",
      "brand": "Brand, non seguito",
      "cited": "Citato",
      "named": "Nominato",
      "notFoundTitle": "Prompt non trovato",
      "notFoundBody": "Potrebbe venire da un'esecuzione precedente, o il link non è più valido.",
      "back": "Torna alle risposte AI",
      "writtenFrom": "Scritto dalla pagina",
      "kind": {
        "category": "Prompt di categoria",
        "brand": "Prompt di marca"
      }
    },
    "social": {
      "windowAria": "Periodo",
      "windowDays": "{days} giorni",
      "allTime": "Sempre",
      "figures": {
        "impressions": "Impression",
        "impressionsSub": "Su {count} post | Su {count} post",
        "reach": "Copertura",
        "reachSub": "Sommata su tutti i post",
        "engagement": "Tasso di engagement medio",
        "engagementSub": "Reazioni, commenti e condivisioni sulle impression",
        "published": "Post pubblicati",
        "publishedSub": "su {tracked} monitorati · {syncing} in sincronizzazione"
      },
      "weekly": {
        "title": "Impression per settimana",
        "meta": "LinkedIn · nel periodo scelto",
        "aria": "Impression per settimana, nel periodo scelto"
      },
      "posts": {
        "title": "Post pubblicati",
        "meta": "I più visti prima",
        "post": "Post",
        "published": "Pubblicato",
        "impressions": "Impression",
        "reach": "Copertura",
        "engagement": "Engagement",
        "clicks": "Clic",
        "syncing": "In sincronizzazione da LinkedIn",
        "emptyTitle": "Niente di pubblicato in questo periodo",
        "emptyBody": "Scegli un periodo più lungo per vedere i post meno recenti."
      },
      "emptyTitle": "Ancora nessun post pubblicato",
      "emptyBody": "Quando un post esce su LinkedIn, Raldo ne sincronizza impression, copertura ed engagement ogni sei ore.",
      "emptyCta": "Apri la bacheca",
      "loadError": "Impossibile caricare i tuoi numeri social"
    }
  },
  "calendar": {
    "view": {
      "board": "Bacheca",
      "calendar": "Calendario",
      "aria": "Vista"
    },
    "columns": {
      "review": "Da rivedere",
      "scheduled": "Programmati",
      "published": "Pubblicati",
      "reviewEmpty": "Niente da rivedere",
      "scheduledEmpty": "Niente di programmato",
      "publishedEmpty": "Niente di pubblicato",
      "lastDays": "Ultimi {count} giorni",
      "writing": "In scrittura",
      "showOlder": "Mostra i precedenti"
    },
    "card": {
      "post": "Post",
      "postPages": "Post · {count} pagina | Post · {count} pagine",
      "when": "{day} · {time}",
      "impressions": "impression",
      "engagement": "engagement",
      "writingAria": "Raldo sta scrivendo questo post",
      "actionsAria": "Azioni per {title}"
    },
    "day": {
      "yesterday": "Ieri",
      "today": "Oggi",
      "tomorrow": "Domani"
    },
    "badge": {
      "writing": "In scrittura",
      "failed": "Non riuscito",
      "needsPerson": "Serve una persona"
    },
    "state": {
      "writing": "In scrittura",
      "failed": "Non riuscito",
      "published": "Pubblicato",
      "scheduled": "Programmato",
      "awaitingArtwork": "In attesa della grafica",
      "draft": "Bozza",
      "needsPerson": "Serve una persona"
    },
    "measuring": "In misurazione",
    "editedByYou": "Modificato da te",
    "pages": "{count} pagina | {count} pagine",
    "openSlot": "Slot libero",
    "noDateTray": "Ancora senza data · {count}",
    "nothingPlanned": "Niente in programma",
    "dock": {
      "failed": "Non riuscito",
      "whatItArgues": "Cosa sostiene",
      "topic": "Argomento · {name}",
      "history": "Cronologia · {count} versione | Cronologia · {count} versioni",
      "articleState": "A che punto è",
      "writing": "Raldo sta scrivendo le sezioni.",
      "todo": "Da fare · {count} | Da fare · {count}",
      "more": "+ altri {count}",
      "outline": "Struttura",
      "verified": "Verificato il {date}",
      "openPublished": "Apri la pagina pubblicata",
      "goesLive": "Una pagina va online quando aggiungi il suo link pubblicato, non programmandola.",
      "planning": "Raldo sta pianificando e facendo ricerche per questa pagina.",
      "askArticlePlaceholder": "Chiedi a Raldo su questa pagina…",
      "checked": "Raldo ha controllato la bozza.",
      "needsPerson": "Serve una persona"
    },
    "toast": {
      "reconnectFirst": "Ricollega prima LinkedIn.",
      "writing": "Raldo sta ancora scrivendo questo post. Non ha ancora un testo da programmare.",
      "article": "Una pagina va online quando aggiungi il suo link pubblicato, non programmandola.",
      "neverPublishes": "Trascinare non pubblica mai. Apri il post e usa Pubblica ora.",
      "publishedStays": "Un post pubblicato resta pubblicato. LinkedIn non permette di modificarlo o ritirarlo.",
      "noBody": "Questo post non ha ancora un testo da programmare.",
      "connectFirst": "Collega prima LinkedIn."
    },
    "notConnected": "LinkedIn non è collegato, quindi i post programmati non possono uscire."
  },
  "inbox": {
    "newNote": "Nuova nota",
    "tabsAria": "Vista della posta in arrivo",
    "loading": "Caricamento della posta in arrivo",
    "listAria": "Elementi della posta in arrivo",
    "group": {
      "today": "Oggi",
      "thisWeek": "Questa settimana",
      "earlier": "Prima"
    },
    "sender": {
      "raldo": "Raldo",
      "linkedin": "LinkedIn",
      "you": "Tu"
    },
    "when": "{day}, {time}",
    "note": {
      "viaTelegram": "via Telegram",
      "editAria": "Modifica questa nota"
    },
    "composer": {
      "title": "Nuova nota",
      "add": "Aggiungi nota",
      "addLink": "Aggiungi un link",
      "addImage": "Aggiungi un'immagine",
      "linkPlaceholder": "Incolla un link e premi Invio",
      "hint": "Raldo legge le tue note quando pianifica e scrive."
    },
    "error": {
      "publish_failed": "LinkedIn non ha accettato il post.",
      "publish_partial": "Il post è stato pubblicato su alcuni canali ma non su tutti.",
      "linkedin_account_not_connected": "LinkedIn non è collegato.",
      "design_page_render_missing": "Non è stato possibile generare una pagina del design.",
      "unexpected_error": "Qualcosa è andato storto.",
      "article_health_check_failed": "L'articolo non ha superato il controllo.",
      "token_revoked": "L'accesso a LinkedIn è stato revocato. Ricollega l'account.",
      "unknown": "Qualcosa è andato storto.",
      "brand_style_enqueue_failed": "Impossibile avviare lo stile del brand.",
      "brand_style_failed": "Raldo non è riuscito a disegnare lo stile del brand.",
      "brand_style_rejected": "I layout non hanno superato i controlli.",
      "run_timed_out": "L'esecuzione ha impiegato troppo tempo."
    },
    "toast": {
      "actionFailed": "Impossibile aggiornare la posta in arrivo",
      "sent": "Inviato a Raldo.",
      "later": "Messo da parte. Il conteggio arancione lo tiene."
    },
    "unread": "Non letto",
    "markAllRead": "Segna tutto come letto",
    "archive": "Archivia",
    "unarchive": "Ripristina",
    "deleted": "Questo elemento è stato eliminato",
    "empty": {
      "inbox": {
        "title": "Ancora niente qui.",
        "description": "Raldo scrive quando una bozza, una domanda o un risultato ha bisogno di te."
      },
      "unread": {
        "title": "Sei in pari."
      },
      "important": {
        "title": "Niente di importante al momento."
      },
      "sent": {
        "title": "Ancora nessuna nota.",
        "description": "Tutto ciò che Raldo dovrebbe sapere arriva qui."
      },
      "archive": {
        "title": "Niente in archivio.",
        "description": "I messaggi archiviati si trovano qui."
      }
    },
    "researchKind": {
      "brandFacts": "I fatti del tuo brand",
      "customerProfile": "Il profilo dei tuoi clienti",
      "contentStrategy": "La strategia dei contenuti",
      "competitors": "L'analisi dei concorrenti",
      "visibility": "Il controllo della visibilità",
      "aiAnswers": "Il controllo delle risposte IA",
      "documents": "La ricerca sui documenti"
    },
    "selectPrompt": "Seleziona un messaggio",
    "build": {
      "title": "Raldo sta costruendo il tuo piano",
      "steps": {
        "snapshot": {
          "title": "Istantanea della ricerca",
          "caption": "Tu nella ricerca e nelle risposte IA | Tu e il tuo concorrente nella ricerca e nelle risposte IA | Tu e i tuoi {count} concorrenti nella ricerca e nelle risposte IA"
        },
        "plan": {
          "title": "Piano dei contenuti",
          "caption": "Le pagine e i post da fare per primi"
        },
        "answers": {
          "title": "Controllo delle risposte IA",
          "caption": "Dove ChatGPT e Perplexity ti nominano"
        }
      }
    },
    "missing": "Questo messaggio non è più qui",
    "subject": {
      "articleQuestions": "{count} domanda su {page} | {count} domande su {page}",
      "articleReady": {
        "completed": "Pagina pronta: {page}",
        "partial": "Pagina pronta, con lacune: {page}"
      },
      "planProposal": "Modifiche al piano da rivedere",
      "planTopics": "{count} tema da rivedere | {count} temi da rivedere",
      "planReminder": {
        "reviewTopics": "Ancora in attesa: i tuoi temi",
        "reviewPlan": "Ancora in attesa: il tuo piano"
      },
      "planReady": {
        "completed": "Il tuo piano è pronto",
        "partial": "Il tuo piano è pronto, con lacune"
      },
      "postDraft": "Bozza pronta: {title}",
      "postPublishFailed": "Pubblicazione non riuscita: {title}",
      "postPublished": "Pubblicato: {title}",
      "postResults": "Risultati: {title}",
      "runFailed": "Non completato: {run}",
      "accountDisconnected": "{platform} disconnesso",
      "researchReady": "Pronto: {research}",
      "designReady": {
        "no": "Il tuo design è pronto",
        "yes": "Design pronto, mancano pagine"
      },
      "brandStyleReady": "Il tuo nuovo stile del brand è pronto",
      "brandStyleDecided": {
        "used": "Stile del brand aggiornato",
        "discarded": "Stile del brand scartato"
      }
    },
    "line": {
      "articleQuestions": "Una domanda veloce prima di continuare a scrivere. | {count} domande veloci prima di continuare a scrivere.",
      "articleReady": {
        "completed": "Scritta, rivista e controllata. Leggila quando hai un momento.",
        "partial": "Alcune sezioni vogliono un tuo sguardo prima di andare avanti."
      },
      "planProposal": "{changes}. Non si muove nulla finché non lo dici tu.",
      "planTopics": "Tieni quelli che vuoi seguire. Non si pianifica nulla finché non lo dici tu.",
      "planReminder": {
        "reviewTopics": "Te l'ho chiesto 7 giorni fa. L'esecuzione aspetta; scartala se non la vuoi più.",
        "reviewPlan": "Te l'ho chiesto 7 giorni fa. L'esecuzione aspetta; scartala se non la vuoi più."
      },
      "planReady": {
        "completed": "Ogni pagina per argomento, nell'ordine in cui le scriverei.",
        "partial": "Mancano alcune parti. Sono segnate."
      },
      "postDraft": {
        "yes": "{hook}",
        "no": "Pronta da leggere."
      },
      "postPublishFailed": "{error}",
      "postPublished": "Online su LinkedIn. Ti scrivo con i numeri tra circa una settimana.",
      "postResults": "{impressions} impression, {clicks} clic, {rate} di coinvolgimento.",
      "runFailed": "{error}",
      "accountDisconnected": "I post programmati restano fermi finché non ti ricolleghi.",
      "researchReady": {
        "brandFacts": "Cosa ho letto sulla tua azienda e dove l'ho letto.",
        "customerProfile": "Per chi scrivi, con le sue parole.",
        "contentStrategy": "Cosa sostieni e di cosa scrivi.",
        "competitors": "Gli altri nomi che i tuoi acquirenti prendono in considerazione e come ti confronti.",
        "visibility": "Dove gli acquirenti ti trovano questo mese e dove non ancora.",
        "aiAnswers": "Dove ChatGPT e Perplexity ti nominano.",
        "documents": "Cosa ho ricavato dai tuoi documenti."
      },
      "designReady": {
        "no": "Allegato al post. Aprilo per controllare.",
        "yes": "Alcune pagine non si sono potute allegare al post."
      },
      "brandStyleReady": "Disegnato da {design}. Sedici layout da rivedere.",
      "brandStyleDecided": {
        "used": "I nuovi design lo usano da ora.",
        "discarded": "Il tuo stile del brand non è cambiato."
      }
    },
    "body": {
      "articleQuestions": [
        "Sto scrivendo {page} e c'è una cosa che non trovo nelle tue fonti. | Sto scrivendo {page} e ci sono {count} cose che non trovo nelle tue fonti.",
        "Rispondi nella pagina e riprendo il lavoro dal punto in cui si è interrotto. Tirare a indovinare indebolirebbe l'argomento."
      ],
      "articleReady": {
        "completed": [
          "Ho scritto, rivisto e controllato {page}. Aprila per leggerla e pubblicarla."
        ],
        "partial": [
          "Ho finito di {page} quello che potevo. Alcune sezioni vogliono un tuo sguardo prima di andare avanti. Sono segnate."
        ]
      },
      "planProposal": [
        "Le ricerche dei tuoi acquirenti sono cambiate, quindi propongo modifiche al tuo piano: {changes}.",
        "Non cambia nulla finché non l'hai rivisto."
      ],
      "planTopics": [
        "Ho letto le ricerche che digitano i tuoi clienti e propongo {count} tema. | Ho letto le ricerche che digitano i tuoi clienti e propongo {count} temi.",
        "Tieni, rinomina o rimuovi qualsiasi tema, oppure aggiungi il tuo. Non si pianifica nulla finché non approvi."
      ],
      "planReminder": {
        "reviewTopics": [
          "Te l'ho chiesto 7 giorni fa. L'esecuzione aspetta; scartala se non la vuoi più."
        ],
        "reviewPlan": [
          "Te l'ho chiesto 7 giorni fa. L'esecuzione aspetta; scartala se non la vuoi più."
        ]
      },
      "planReady": {
        "completed": [
          "Il tuo piano editoriale è pronto: ogni pagina per argomento, nell'ordine in cui le scriverei. Dagli un'occhiata."
        ],
        "partial": [
          "Il tuo piano editoriale è pronto, ma alcune parti non sono state completate. Le lacune sono segnate."
        ]
      },
      "postDraft": {
        "yes": [
          "La tua bozza è pronta. Inizia così: “{hook}”",
          "Leggila una volta, poi programmala."
        ],
        "no": ["La tua bozza è pronta.", "Leggila una volta, poi programmala."]
      },
      "postPublishFailed": [
        "LinkedIn non ha accettato “{title}”. {error}",
        "Sistema ciò che indica e riprova. Al resto penso io."
      ],
      "postPublished": [
        "“{title}” è online su LinkedIn. Controllo i numeri e ti scrivo tra circa una settimana."
      ],
      "postResults": ["Una settimana dopo, ecco come è andato “{title}”."],
      "runFailed": [
        "Operazione interrotta prima della fine: {run}. {error}",
        "Riavviala quando sei pronto."
      ],
      "accountDisconnected": [
        "{platform} ha interrotto la connessione. {error}",
        "Non esce nulla finché non lo ricolleghi. Due clic."
      ],
      "researchReady": {
        "brandFacts": [
          "Ho letto il tuo sito e annotato cosa è vero sulla tua azienda, con la pagina da cui viene ogni fatto. Controllami."
        ],
        "customerProfile": [
          "Ho disegnato la persona dall'altra parte dei tuoi post da ciò che dicono gli acquirenti. Vedi se la riconosci."
        ],
        "contentStrategy": [
          "La tua strategia dei contenuti è pronta: cosa sostieni e di cosa scrivi. Leggila e confermala."
        ],
        "competitors": [
          "Ho guardato i nomi con cui i tuoi acquirenti ti confrontano e dove ti distingui. Dagli un'occhiata."
        ],
        "visibility": [
          "Il controllo di questo mese è pronto: dove gli acquirenti ti trovano su Google e nelle risposte dell'IA, e dove non ancora."
        ],
        "aiAnswers": [
          "Ho fatto a ChatGPT e Perplexity le domande dei tuoi acquirenti e ho annotato dove compari."
        ],
        "documents": ["Ho letto i tuoi documenti e ricavato ciò che posso usare quando scrivo."]
      },
      "designReady": {
        "no": [
          "Il tuo design è disegnato e allegato al post. Aprilo e controllalo prima che esca."
        ],
        "yes": [
          "Il tuo design è disegnato, ma non tutte le pagine si sono potute allegare al post. Aprilo per vedere quali."
        ]
      },
      "brandStyleReady": [
        "Ho disegnato uno stile del brand da {design}: sedici layout con i suoi colori e i suoi caratteri.",
        "Usalo o scartalo. I nuovi design lo seguiranno da allora in poi."
      ],
      "brandStyleDecided": {
        "used": ["Il nuovo stile è ora il tuo stile del brand. I nuovi design lo usano da ora."],
        "discarded": [
          "Hai scartato il nuovo stile del brand. Il tuo stile del brand non è cambiato."
        ]
      }
    },
    "verb": {
      "articleQuestions": "Rispondi nella pagina",
      "articleReady": "Apri la pagina",
      "planProposal": "Rivedi il piano",
      "planTopics": "Rivedi i temi",
      "planReminder": {
        "reviewTopics": "Rivedi i temi",
        "reviewPlan": "Rivedi il piano"
      },
      "planReady": "Apri il piano",
      "postDraft": "Apri il post",
      "postPublishFailed": "Riprova",
      "postPublished": "Apri il post",
      "postResults": "Apri il post",
      "runFailed": "Apri",
      "accountDisconnected": "Ricollega",
      "researchReady": "Apri",
      "designReady": "Apri il post",
      "brandStyleReady": "Rivedi",
      "brandStyleDecided": "Apri",
      "note": "Modifica"
    },
    "verbSecondary": {
      "postPublishFailed": "Apri il post"
    },
    "changes": {
      "topics": "{n} argomento modificato | {n} argomenti modificati",
      "added": "{n} pagina aggiunta | {n} pagine aggiunte",
      "removed": "{n} pagina rimossa | {n} pagine rimosse",
      "changed": "{n} pagina modificata | {n} pagine modificate"
    },
    "runName": {
      "article": "Articolo",
      "post": "Post",
      "plan": "Piano",
      "design": "Design",
      "design-edit": "Modifica del design",
      "brand-style": "Stile del brand",
      "other": "Esecuzione"
    },
    "important": "Importante",
    "later": "Più tardi",
    "more": "+{n} in Posta in arrivo",
    "selected": "{n} selezionati",
    "markRead": "Segna come letto",
    "count": "{n} messaggio | {n} messaggi",
    "selectMessage": "Seleziona messaggio",
    "clearSelection": "Annulla selezione",
    "filter": {
      "aria": "Filtra i messaggi",
      "all": "Tutti"
    },
    "toYou": "a te",
    "toRaldo": "a Raldo",
    "earlierInThread": "Prima in questa conversazione",
    "position": "{n} / {total}",
    "markUnread": "Segna come non letto",
    "moveToInbox": "Sposta nella posta in arrivo",
    "previous": "Messaggio precedente",
    "next": "Messaggio successivo"
  },
  "pages": {
    "write": "Scrivi una pagina",
    "filterAria": "Mostra le pagine per stato",
    "emptyFilter": {
      "planned": "Nessuna pagina pianificata",
      "writing": "Nessuna pagina in scrittura",
      "live": "Nessuna pagina online",
      "site": "Nessuna pagina sul tuo sito"
    },
    "emptyFilterBody": "Scegli un altro filtro per vedere il resto del piano.",
    "menu": {
      "aria": "Azioni per {title}",
      "open": "Apri",
      "write": "Scrivi la pagina",
      "openAddress": "Apri l'indirizzo",
      "copyAddress": "Copia l'indirizzo",
      "copied": "Indirizzo copiato"
    },
    "nextUp": "Prossima",
    "topics": "Temi",
    "topicsMeta": "{count} tema | {count} temi",
    "next": "Prossima: {question}",
    "everyPageWritten": "Ogni pagina è scritta",
    "backToPages": "Torna alle Pagine"
  },
  "posts": {
    "filterAria": "Mostra i post per stato",
    "emptyTitle": "Ancora nessun post",
    "emptyBody": "Raldo scrive un post dai tuoi argomenti e dalla tua ricerca.",
    "row": {
      "text": "Testo",
      "pages": "{count} pagina | {count} pagine"
    }
  }
}
